
// // // // // import React, { useState } from 'react';
// // // // // import { useNavigate } from 'react-router-dom';
// // // // // import styled from 'styled-components';
// // // // // import { FaEye, FaEyeSlash } from "react-icons/fa"; // 🔥 IMPORTED ICONS
// // // // // import api from '../api';
// // // // // import LogoImg from "./assets/performance_logo.png";

// // // // // /* ================= STYLED COMPONENTS ================= */
// // // // // const LoginContainer = styled.div`
// // // // //   background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
// // // // //   min-height: 100vh;
// // // // //   display: flex;
// // // // //   justify-content: center;
// // // // //   align-items: center;
// // // // //   padding: 20px;
// // // // // `;

// // // // // const LoginCard = styled.div`
// // // // //   background-color: #fff;
// // // // //   padding: 40px;
// // // // //   border-radius: 24px;
// // // // //   box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
// // // // //   width: 100%;
// // // // //   max-width: 420px;
// // // // //   text-align: center;
// // // // // `;

// // // // // const Logo = styled.img`
// // // // //   width: 180px;
// // // // //   margin-bottom: 20px;
// // // // // `;

// // // // // const Title = styled.h2`
// // // // //   color: #0f172a;
// // // // //   font-weight: 800;
// // // // //   margin-bottom: 10px;
// // // // // `;

// // // // // const Subtitle = styled.p`
// // // // //   color: #64748b;
// // // // //   font-size: 0.9rem;
// // // // //   margin-bottom: 30px;
// // // // // `;

// // // // // const FormGroup = styled.div`
// // // // //   margin-bottom: 20px;
// // // // //   text-align: left;
// // // // // `;

// // // // // const Label = styled.label`
// // // // //   display: block;
// // // // //   color: #1e293b;
// // // // //   margin-bottom: 8px;
// // // // //   font-size: 14px;
// // // // //   font-weight: 700;
// // // // // `;

// // // // // const Input = styled.input`
// // // // //   width: 100%;
// // // // //   padding: 12px 16px;
// // // // //   border: 2px solid #e2e8f0;
// // // // //   border-radius: 12px;
// // // // //   font-size: 16px;
// // // // //   transition: all 0.2s;
// // // // //   box-sizing: border-box; /* Important for inputs */
// // // // //   &:focus {
// // // // //     outline: none;
// // // // //     border-color: #2563eb;
// // // // //     box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
// // // // //   }
// // // // // `;

// // // // // // 🔥 NEW: Password Input Wrapper & Eye Button Styles 🔥
// // // // // const PasswordInputWrapper = styled.div` 
// // // // //   position: relative; 
// // // // //   display: flex; 
// // // // //   align-items: center; 
// // // // // `;

// // // // // const PasswordInput = styled(Input)` 
// // // // //   padding-right: 48px; /* Make room for the eye icon so text doesn't type under it */
// // // // //   &::-ms-reveal, &::-ms-clear { display: none; } /* Hides Edge's default eye icon */
// // // // // `;

// // // // // const EyeButton = styled.button` 
// // // // //   position: absolute; 
// // // // //   right: 14px; 
// // // // //   background: none; 
// // // // //   border: none; 
// // // // //   color: #94a3b8; 
// // // // //   font-size: 18px; 
// // // // //   cursor: pointer; 
// // // // //   display: flex; 
// // // // //   align-items: center; 
// // // // //   justify-content: center; 
// // // // //   padding: 0; 
// // // // //   transition: color 0.2s ease; 
// // // // //   &:hover { color: #3b82f6; } 
// // // // // `;


// // // // // // Styled Select for Role
// // // // // const Select = styled.select`
// // // // //   width: 100%;
// // // // //   padding: 12px 16px;
// // // // //   border: 2px solid #e2e8f0;
// // // // //   border-radius: 12px;
// // // // //   font-size: 16px;
// // // // //   background-color: #f8fafc;
// // // // //   cursor: pointer;
// // // // //   font-weight: 600;
// // // // //   box-sizing: border-box;
// // // // //   &:focus {
// // // // //     outline: none;
// // // // //     border-color: #2563eb;
// // // // //   }
// // // // // `;

// // // // // const SubmitButton = styled.button`
// // // // //   width: 100%;
// // // // //   padding: 14px;
// // // // //   background-color: #2563eb;
// // // // //   border: none;
// // // // //   border-radius: 12px;
// // // // //   color: #fff;
// // // // //   font-size: 16px;
// // // // //   font-weight: 800;
// // // // //   cursor: pointer;
// // // // //   margin-top: 10px;
// // // // //   transition: transform 0.2s, background 0.2s;

// // // // //   &:hover {
// // // // //     background-color: #1d4ed8;
// // // // //     transform: translateY(-1px);
// // // // //   }
// // // // //   &:disabled {
// // // // //     background-color: #94a3b8;
// // // // //   }
// // // // // `;

// // // // // const ErrorMsg = styled.div`
// // // // //   background-color: #fef2f2;
// // // // //   color: #dc2626;
// // // // //   padding: 12px;
// // // // //   border-radius: 10px;
// // // // //   font-size: 14px;
// // // // //   font-weight: 600;
// // // // //   margin-bottom: 20px;
// // // // //   border: 1px solid #fee2e2;
// // // // // `;

// // // // // /* ================= MAIN COMPONENT ================= */
// // // // // const Login = ({ setUser }) => {
// // // // //   const [username, setUsername] = useState('');
// // // // //   const [password, setPassword] = useState('');
// // // // //   const [selectedRole, setSelectedRole] = useState('staff'); 
// // // // //   const [loading, setLoading] = useState(false);
// // // // //   const [error, setError] = useState('');
  
// // // // //   // 🔥 NEW: State for toggling password visibility
// // // // //   const [showPassword, setShowPassword] = useState(false);
  
// // // // //   const navigate = useNavigate();

// // // // //   const handleLogin = async (e) => {
// // // // //     e.preventDefault();
// // // // //     setLoading(true);
// // // // //     setError("");

// // // // //     try {
// // // // //       const { data } = await api.post("/auth/login", {
// // // // //         username,
// // // // //         password,
// // // // //         role: selectedRole, 
// // // // //       });

// // // // //       localStorage.setItem("token", data.token);
// // // // //       localStorage.setItem("user", JSON.stringify(data.user));

// // // // //       setUser(data.user);

// // // // //       // Redirect based on the role they JUST selected
// // // // //       if (data.user.role === "super_admin") {
// // // // //         navigate("/super-admin/dashboard");
// // // // //       } else if (data.user.role === "admin") {
// // // // //         navigate("/admin/dashboard");
// // // // //       } else if (data.user.role === "supervisor") {
// // // // //         navigate("/supervisor/dashboard");
// // // // //       } else {
// // // // //         navigate("/dashboard");
// // // // //       }
// // // // //     } catch (error) {
// // // // //       setError(error.response?.data?.message || "Invalid credentials. Please try again.");
// // // // //     } finally {
// // // // //       setLoading(false);
// // // // //     }
// // // // //   };

// // // // //   return (
// // // // //     <LoginContainer>
// // // // //       <LoginCard>
// // // // //         <div style={{ fontSize: "1.1rem", fontWeight: 800, letterSpacing: "-0.03em", color: "#0f172a",marginLeft:"-9px", marginBottom: "30px" }}>
// // // // //           <span style={{ color: "#2563eb" }}>Performance</span>Pro
// // // // //         </div>

// // // // //         {error && <ErrorMsg>{error}</ErrorMsg>}

// // // // //         <form onSubmit={handleLogin}>
// // // // //           <FormGroup>
// // // // //             <Label>Username</Label>
// // // // //             <Input 
// // // // //               type="text"
// // // // //               value={username}
// // // // //               onChange={(e) => setUsername(e.target.value)}
// // // // //               required
// // // // //               placeholder=""
// // // // //             />
// // // // //           </FormGroup>

// // // // //           {/* 🔥 UPDATED: Password field wrapped with Eye icon logic */}
// // // // //           <FormGroup>
// // // // //             <Label>Password</Label>
// // // // //             <PasswordInputWrapper>
// // // // //               <PasswordInput
// // // // //                 type={showPassword ? "text" : "password"} // Switches input type based on state
// // // // //                 value={password}
// // // // //                 onChange={(e) => setPassword(e.target.value)}
// // // // //                 required
// // // // //                 placeholder="••••••••"
// // // // //               />
// // // // //               <EyeButton type="button" onClick={() => setShowPassword(!showPassword)}>
// // // // //                 {showPassword ? <FaEyeSlash /> : <FaEye />}
// // // // //               </EyeButton>
// // // // //             </PasswordInputWrapper>
// // // // //           </FormGroup>

// // // // //           <FormGroup>
// // // // //             <Label>Login As</Label>
// // // // //             <Select 
// // // // //               value={selectedRole} 
// // // // //               onChange={(e) => setSelectedRole(e.target.value)}
// // // // //             >
// // // // //               <option value="staff">Staff Member</option>
// // // // //               <option value="supervisor">Supervisor</option>
// // // // //               <option value="admin">Admin</option>
// // // // //               <option value="super_admin">Super Admin</option>
// // // // //             </Select>
// // // // //           </FormGroup>

// // // // //           <SubmitButton type="submit" disabled={loading}>
// // // // //             {loading ? 'Authenticating...' : 'Sign In'}
// // // // //           </SubmitButton>
// // // // //         </form>
// // // // //       </LoginCard>
// // // // //     </LoginContainer>
// // // // //   );
// // // // // };

// // // // // export default Login;















// // // // import React, { useState } from 'react';
// // // // import { useNavigate } from 'react-router-dom';
// // // // import styled from 'styled-components';
// // // // import { FaEye, FaEyeSlash } from "react-icons/fa";
// // // // import api from '../api';
// // // // import LogoImg from "./assets/performance_logo.png";

// // // // /* ================= STYLED COMPONENTS ================= */
// // // // const LoginContainer = styled.div`
// // // //   background: linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.75)), 
// // // //               url('https://via.placeholder.com/1920x1080/0a1f3d/1e3a8a?text=HERALD+STAGE') center/cover no-repeat;
  
// // // //   min-height: 100vh;
// // // //   display: flex;
// // // //   flex-direction: column;
// // // //   color: white;
// // // //   position: relative;
// // // //   overflow: hidden;
// // // // `;

// // // // const Header = styled.header`
// // // //   background: rgba(15, 23, 42, 0.95);
// // // //   padding: 12px 40px;
// // // //   display: flex;
// // // //   align-items: center;
// // // //   justify-content: space-between;
// // // //   position: fixed;
// // // //   width: 100%;
// // // //   z-index: 100;
// // // //   border-bottom: 1px solid rgba(255,255,255,0.1);
// // // // `;

// // // // const Nav = styled.nav`
// // // //   display: flex;
// // // //   gap: 32px;
// // // //   align-items: center;
// // // // `;

// // // // const NavLink = styled.a`
// // // //   color: white;
// // // //   text-decoration: none;
// // // //   font-weight: 600;
// // // //   cursor: pointer;
// // // //   &:hover {
// // // //     color: #fcd34d;
// // // //   }
// // // // `;

// // // // const HeaderRight = styled.div`
// // // //   display: flex;
// // // //   align-items: center;
// // // //   gap: 16px;
// // // // `;

// // // // const ContactInfo = styled.div`
// // // //   font-size: 0.85rem;
// // // //   color: #cbd5e1;
// // // // `;

// // // // const MainContent = styled.div`
// // // //   flex: 1;
// // // //   display: flex;
// // // //   align-items: center;
// // // //   justify-content: center;
// // // //   padding-top: 80px;
// // // //   position: relative;
// // // // `;

// // // // const HeroSection = styled.div`
// // // //   text-align: center;
// // // //   max-width: 1100px;
// // // //   padding: 0 20px;
// // // //   z-index: 10;
// // // // `;

// // // // const HeraldLogo = styled.div`
// // // //   font-size: 5.5rem;
// // // //   font-weight: 900;
// // // //   letter-spacing: -4px;
// // // //   color: #fcd34d;
// // // //   margin-bottom: 16px;
// // // //   text-shadow: 0 4px 20px rgba(0,0,0,0.6);
// // // //   display: flex;
// // // //   align-items: center;
// // // //   justify-content: center;
// // // //   gap: 12px;
// // // // `;

// // // // const SubtitleText = styled.p`
// // // //   font-size: 1.35rem;
// // // //   margin-bottom: 8px;
// // // //   font-weight: 600;
// // // //   color: #e0f2fe;
// // // // `;

// // // // const Tagline = styled.p`
// // // //   font-size: 1.1rem;
// // // //   color: #bae6fd;
// // // //   margin-bottom: 40px;
// // // //   max-width: 600px;
// // // //   margin-left: auto;
// // // //   margin-right: auto;
// // // // `;

// // // // const ButtonsContainer = styled.div`
// // // //   display: flex;
// // // //   gap: 20px;
// // // //   justify-content: center;
// // // //   flex-wrap: wrap;
// // // // `;

// // // // const BecomeButton = styled.button`
// // // //   padding: 16px 48px;
// // // //   background: #fcd34d;
// // // //   color: #1e2937;
// // // //   border: none;
// // // //   border-radius: 50px;
// // // //   font-size: 1.1rem;
// // // //   font-weight: 800;
// // // //   cursor: pointer;
// // // //   transition: all 0.3s;
// // // //   box-shadow: 0 10px 15px -3px rgba(251, 191, 36, 0.4);

// // // //   &:hover {
// // // //     transform: translateY(-4px);
// // // //     background: #facc15;
// // // //     box-shadow: 0 20px 25px -5px rgba(251, 191, 36, 0.5);
// // // //   }
// // // // `;

// // // // const SignInButton = styled.button`
// // // //   padding: 16px 48px;
// // // //   background: rgba(255,255,255,0.15);
// // // //   color: white;
// // // //   border: 2px solid rgba(255,255,255,0.6);
// // // //   border-radius: 50px;
// // // //   font-size: 1.1rem;
// // // //   font-weight: 700;
// // // //   cursor: pointer;
// // // //   backdrop-filter: blur(8px);
// // // //   transition: all 0.3s;

// // // //   &:hover {
// // // //     background: rgba(255,255,255,0.25);
// // // //     border-color: white;
// // // //   }
// // // // `;

// // // // // Login Form Overlay (Modal Style)
// // // // const LoginOverlay = styled.div`
// // // //   position: absolute;
// // // //   top: 50%;
// // // //   right: 8%;
// // // //   transform: translateY(-50%);
// // // //   background: rgba(255,255,255,0.98);
// // // //   padding: 40px;
// // // //   border-radius: 24px;
// // // //   box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.4);
// // // //   width: 100%;
// // // //   max-width: 420px;
// // // //   color: #0f172a;
// // // //   z-index: 20;
// // // // `;

// // // // const Logo = styled.img`
// // // //   width: 140px;
// // // //   margin-bottom: 24px;
// // // // `;

// // // // const Title = styled.h2`
// // // //   color: #0f172a;
// // // //   font-weight: 800;
// // // //   margin-bottom: 8px;
// // // //   font-size: 2rem;
// // // // `;

// // // // const Subtitle = styled.p`
// // // //   color: #64748b;
// // // //   margin-bottom: 32px;
// // // // `;

// // // // const Form = styled.form``;

// // // // const FormGroup = styled.div`
// // // //   margin-bottom: 20px;
// // // //   text-align: left;
// // // // `;

// // // // const Label = styled.label`
// // // //   display: block;
// // // //   color: #1e293b;
// // // //   margin-bottom: 8px;
// // // //   font-size: 14px;
// // // //   font-weight: 700;
// // // // `;

// // // // const Input = styled.input`
// // // //   width: 100%;
// // // //   padding: 14px 16px;
// // // //   border: 2px solid #e2e8f0;
// // // //   border-radius: 12px;
// // // //   font-size: 16px;
// // // //   transition: all 0.2s;
// // // //   box-sizing: border-box;

// // // //   &:focus {
// // // //     outline: none;
// // // //     border-color: #2563eb;
// // // //     box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
// // // //   }
// // // // `;

// // // // const PasswordInputWrapper = styled.div` 
// // // //   position: relative; 
// // // //   display: flex; 
// // // //   align-items: center; 
// // // // `;

// // // // const PasswordInput = styled(Input)` 
// // // //   padding-right: 52px;
// // // //   &::-ms-reveal, &::-ms-clear { display: none; }
// // // // `;

// // // // const EyeButton = styled.button` 
// // // //   position: absolute; 
// // // //   right: 16px; 
// // // //   background: none; 
// // // //   border: none; 
// // // //   color: #64748b; 
// // // //   font-size: 20px; 
// // // //   cursor: pointer;
// // // //   display: flex;
// // // //   align-items: center;
// // // //   padding: 0;
// // // //   &:hover { color: #3b82f6; }
// // // // `;

// // // // const Select = styled.select`
// // // //   width: 100%;
// // // //   padding: 14px 16px;
// // // //   border: 2px solid #e2e8f0;
// // // //   border-radius: 12px;
// // // //   font-size: 16px;
// // // //   background-color: #f8fafc;
// // // //   cursor: pointer;
// // // // `;

// // // // const SubmitButton = styled.button`
// // // //   width: 100%;
// // // //   padding: 16px;
// // // //   background-color: #1e40af;
// // // //   border: none;
// // // //   border-radius: 50px;
// // // //   color: #fff;
// // // //   font-size: 1.1rem;
// // // //   font-weight: 800;
// // // //   cursor: pointer;
// // // //   margin-top: 12px;
// // // //   transition: all 0.3s;

// // // //   &:hover {
// // // //     background-color: #1e3a8a;
// // // //     transform: translateY(-2px);
// // // //   }
// // // //   &:disabled {
// // // //     background-color: #94a3b8;
// // // //     transform: none;
// // // //   }
// // // // `;

// // // // const ErrorMsg = styled.div`
// // // //   background-color: #fef2f2;
// // // //   color: #dc2626;
// // // //   padding: 12px 16px;
// // // //   border-radius: 10px;
// // // //   font-size: 14px;
// // // //   margin-bottom: 20px;
// // // //   border: 1px solid #fee2e2;
// // // // `;

// // // // /* ================= MAIN COMPONENT ================= */
// // // // const Login = ({ setUser }) => {
// // // //   const [username, setUsername] = useState('');
// // // //   const [password, setPassword] = useState('');
// // // //   const [selectedRole, setSelectedRole] = useState('staff'); 
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [error, setError] = useState('');
// // // //   const [showPassword, setShowPassword] = useState(false);
  
// // // //   const navigate = useNavigate();

// // // //   const handleLogin = async (e) => {
// // // //     e.preventDefault();
// // // //     setLoading(true);
// // // //     setError("");

// // // //     try {
// // // //       const { data } = await api.post("/auth/login", {
// // // //         username,
// // // //         password,
// // // //         role: selectedRole, 
// // // //       });

// // // //       localStorage.setItem("token", data.token);
// // // //       localStorage.setItem("user", JSON.stringify(data.user));

// // // //       setUser(data.user);

// // // //       if (data.user.role === "super_admin") {
// // // //         navigate("/super-admin/dashboard");
// // // //       } else if (data.user.role === "admin") {
// // // //         navigate("/admin/dashboard");
// // // //       } else if (data.user.role === "supervisor") {
// // // //         navigate("/supervisor/dashboard");
// // // //       } else {
// // // //         navigate("/dashboard");
// // // //       }
// // // //     } catch (err) {
// // // //       setError(err.response?.data?.message || "Invalid credentials. Please try again.");
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   return (
// // // //     <LoginContainer>
// // // //       {/* Header */}
// // // //       <Header>
// // // //         <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
// // // //           <div style={{ color: '#fcd34d', fontWeight: '900', fontSize: '28px' }}>SPIRITMAN Online</div>
// // // //         </div>

// // // //         <Nav>
// // // //           <NavLink>HOME</NavLink>
// // // //           <NavLink>About Us</NavLink>
// // // //           <NavLink>Download Resource</NavLink>
// // // //         </Nav>

// // // //         <HeaderRight>
// // // //           <ContactInfo>
// // // //             spiritman.online<br />
// // // //             +234 813 300 167, +27 79 967 5852
// // // //           </ContactInfo>
// // // //           <div style={{ color: '#fcd34d', fontWeight: 'bold' }}>KingsChat</div>
// // // //         </HeaderRight>
// // // //       </Header>

// // // //       <MainContent>
// // // //         <HeroSection>
// // // //           <HeraldLogo>SPIRITMAN</HeraldLogo>
// // // //           <SubtitleText>Advancing • Nations • Territories • Spreading • Goodnews</SubtitleText>
// // // //           <Tagline>Join us in this mandant, reaching the last lost soul.</Tagline>

// // // //           <ButtonsContainer>
// // // //             <BecomeButton>Become a DIGITAL EVANGELIST</BecomeButton>
// // // //             <SignInButton>Access our Resource</SignInButton>
// // // //           </ButtonsContainer>
// // // //         </HeroSection>

// // // //         {/* Login Form - Positioned like the man in suit on the right */}
// // // //       </MainContent>

// // // //       {/* Decorative Stats (bottom right like in image) */}
// // // //       <div style={{
// // // //         position: 'absolute',
// // // //         bottom: '15%',
// // // //         right: '12%',
// // // //         background: 'rgba(255,255,255,0.1)',
// // // //         padding: '12px 24px',
// // // //         borderRadius: '12px',
// // // //         backdropFilter: 'blur(10px)',
// // // //         border: '1px solid rgba(255,255,255,0.2)',
// // // //         display: 'none' // Hide for now or style further
// // // //       }}>
// // // //         <div style={{ fontSize: '2.2rem', fontWeight: 'bold', color: '#fcd34d' }}>178</div>
// // // //         <div style={{ fontSize: '0.95rem' }}>GERMANY</div>
// // // //       </div>
// // // //     </LoginContainer>
// // // //   );
// // // // };

// // // // export default Login;














// // // import React, { useState } from 'react';
// // // import { useNavigate } from 'react-router-dom';
// // // import styled from 'styled-components';
// // // import { FaEye, FaEyeSlash } from "react-icons/fa";
// // // import api from '../api';
// // // import LogoImg from "./assets/performance_logo.png";
// // // import logo from "../assets/SpitMan.jpeg"; // adjust the path as needed
// // // import { MessageCircle, ExternalLink } from "lucide-react";
// // // /* ================= STYLED COMPONENTS ================= */
// // // const LoginContainer = styled.div`
// // //   position: relative;
// // //   min-height: 100vh;
// // //   overflow: hidden;
// // //   color: white;
// // //   display: flex;
// // //   flex-direction: column;
// // // `;

// // // const BackgroundVideo = styled.video`
// // //   position: absolute;
// // //   top: 0;
// // //   left: 0;
// // //   width: 100%;
// // //   height: 100%;
// // //   object-fit: cover;
// // //   z-index: -2;
// // // `;

// // // const Overlay = styled.div`
// // //   position: absolute;
// // //   top: 0;
// // //   left: 0;
// // //   width: 100%;
// // //   height: 100%;
// // //   ${'' /* background: linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.8)); */}
// // //   ${'' /* z-index: -1; */}
// // // `;

// // // const Header = styled.header`
// // //   background: rgba(15, 23, 42, 0.95);
// // //   padding: 12px 24px;
// // //   display: flex;
// // //   justify-content: space-between;
// // //   align-items: center;
// // //   position: fixed;
// // //   width: 100%;
// // //   z-index: 100;

// // //   @media (max-width: 768px) {
// // //     flex-direction: column;
// // //     gap: 12px;
// // //     padding: 15px;
// // //   }
// // // `;


// // // const Nav = styled.nav`
// // //   display: flex;
// // //   gap: 32px;

// // //   @media (max-width: 768px) {
// // //     flex-wrap: wrap;
// // //     justify-content: center;
// // //     gap: 16px;
// // //   }
// // // `;

// // // const NavLink = styled.a`
// // //   color: white;
// // //   text-decoration: none;
// // //   font-weight: 600;
// // //   cursor: pointer;
// // //   &:hover {
// // //     color: #fcd34d;
// // //   }
// // // `;

// // // const HeaderRight = styled.div`
// // //   display: flex;
// // //   align-items: center;
// // //   gap: 16px;
// // // `;

// // // const ContactInfo = styled.div`
// // //   font-size: 0.85rem;
// // //   color: #cbd5e1;
// // // `;

// // // const MainContent = styled.div`
// // //   flex: 1;
// // //   display: flex;
// // //   align-items: center;
// // //   justify-content: center;
// // //   padding-top: 80px;
// // //   position: relative;
// // //   z-index: 10;
// // // `;

// // // const HeroSection = styled.div`
// // //   text-align: center;
// // //   max-width: 1100px;
// // //   background: rgba(0,0,0,.6);
// // //   padding: 40px 20px;
// // //   border-radius: 15px;

// // //   @media (max-width: 768px) {
// // //     margin: 20px;
// // //     padding: 25px;
// // //   }
// // // `;

// // // const HeraldLogo = styled.div`
// // //   font-size: 3.5rem;

// // //   @media (max-width: 768px) {
// // //     font-size: 2rem;
// // //   }
// // // `;
// // // const ButtonsContainer = styled.div`
// // //   display: flex;
// // //   gap: 20px;
// // //   justify-content: center;

// // //   @media (max-width: 768px) {
// // //     flex-direction: column;
// // //     align-items: center;
// // //   }
// // // `;

// // // const ModalOverlay = styled.div`
// // //   position: fixed;
// // //   inset: 0;
// // //   background: rgba(0,0,0,.75);
// // //   display: flex;
// // //   justify-content: center;
// // //   align-items: center;
// // //   z-index: 999;
// // // `;

// // // const ModalCard = styled.div`
// // //   background: white;
// // //   width: 95%;
// // //   max-width: 500px;
// // //   border-radius: 20px;
// // //   padding: 30px;
// // //   color: black;
// // // `;

// // // const SubtitleText = styled.p`
// // //   font-size: 1.35rem;
// // //   margin-bottom: 8px;
// // //   font-weight: 600;
// // //   color: #e0f2fe;
// // // `;

// // // const Tagline = styled.p`
// // //   font-size: 1.1rem;
// // //   color: #bae6fd;
// // //   margin-bottom: 40px;
// // //   max-width: 600px;
// // //   margin-left: auto;
// // //   margin-right: auto;
// // // `;

// // // // const ButtonsContainer = styled.div`
// // // //   display: flex;
// // // //   gap: 20px;
// // // //   justify-content: center;
// // // //   flex-wrap: wrap;
// // // // `;

// // // const BecomeButton = styled.button`
// // //   padding: 16px 48px;
// // //   background: #fcd34d;
// // //   color: #1e2937;
// // //   border: none;
// // //   border-radius: 50px;
// // //   font-size: 1.1rem;
// // //   font-weight: 800;
// // //   cursor: pointer;
// // //   transition: all 0.3s;
// // //   box-shadow: 0 10px 15px -3px rgba(251, 191, 36, 0.4);

// // //   &:hover {
// // //     transform: translateY(-4px);
// // //     background: #facc15;
// // //   }
// // // `;

// // // const SignInButton = styled.button`
// // //   padding: 16px 48px;
// // //   background: rgba(255,255,255,0.15);
// // //   color: white;
// // //   border: 2px solid rgba(255,255,255,0.6);
// // //   border-radius: 50px;
// // //   font-size: 1.1rem;
// // //   font-weight: 700;
// // //   cursor: pointer;
// // //   backdrop-filter: blur(8px);
// // //   transition: all 0.3s;

// // //   &:hover {
// // //     background: rgba(255,255,255,0.25);
// // //     border-color: white;
// // //   }
// // // `;

// // // // Login Form Overlay
// // // const LoginOverlay = styled.div`
// // //   position: absolute;
// // //   top: 50%;
// // //   right: 8%;
// // //   transform: translateY(-50%);
// // //   background: rgba(255,255,255,0.98);
// // //   padding: 40px;
// // //   border-radius: 24px;
// // //   box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.4);
// // //   width: 100%;
// // //   max-width: 420px;
// // //   color: #0f172a;
// // //   z-index: 20;
// // // `;

// // // /* ================= FORM STYLES (unchanged) ================= */
// // // const Logo = styled.img`
// // //   width: 140px;
// // //   margin-bottom: 24px;
// // // `;

// // // const Title = styled.h2`
// // //   color: #0f172a;
// // //   font-weight: 800;
// // //   margin-bottom: 8px;
// // //   font-size: 2rem;
// // // `;

// // // const Subtitle = styled.p`
// // //   color: #64748b;
// // //   margin-bottom: 32px;
// // // `;

// // // const Form = styled.form``;

// // // const FormGroup = styled.div`
// // //   margin-bottom: 20px;
// // //   text-align: left;
// // // `;

// // // const Label = styled.label`
// // //   display: block;
// // //   color: #1e293b;
// // //   margin-bottom: 8px;
// // //   font-size: 14px;
// // //   font-weight: 700;
// // // `;

// // // const Input = styled.input`
// // //   width: 100%;
// // //   padding: 14px 16px;
// // //   border: 2px solid #e2e8f0;
// // //   border-radius: 12px;
// // //   font-size: 16px;
// // //   transition: all 0.2s;
// // //   box-sizing: border-box;

// // //   &:focus {
// // //     outline: none;
// // //     border-color: #2563eb;
// // //     box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
// // //   }
// // // `;


// // // const PasswordInputWrapper = styled.div` 
// // //   position: relative; 
// // //   display: flex; 
// // //   align-items: center; 
// // // `;

// // // const PasswordInput = styled(Input)` 
// // //   padding-right: 52px;
// // //   &::-ms-reveal, &::-ms-clear { display: none; }
// // // `;

// // // const EyeButton = styled.button` 
// // //   position: absolute; 
// // //   right: 16px; 
// // //   background: none; 
// // //   border: none; 
// // //   color: #64748b; 
// // //   font-size: 20px; 
// // //   cursor: pointer;
// // //   display: flex;
// // //   align-items: center;
// // //   padding: 0;
// // //   &:hover { color: #3b82f6; }
// // // `;

// // // const Select = styled.select`
// // //   width: 100%;
// // //   padding: 14px 16px;
// // //   border: 2px solid #e2e8f0;
// // //   border-radius: 12px;
// // //   font-size: 16px;
// // //   background-color: #f8fafc;
// // //   cursor: pointer;
// // // `;

// // // const SubmitButton = styled.button`
// // //   width: 100%;
// // //   padding: 16px;
// // //   background-color: #1e40af;
// // //   border: none;
// // //   border-radius: 50px;
// // //   color: #fff;
// // //   font-size: 1.1rem;
// // //   font-weight: 800;
// // //   cursor: pointer;
// // //   margin-top: 12px;
// // //   transition: all 0.3s;

// // //   &:hover {
// // //     background-color: #1e3a8a;
// // //     transform: translateY(-2px);
// // //   }
// // //   &:disabled {
// // //     background-color: #94a3b8;
// // //     transform: none;
// // //   }
// // // `;

// // // const CancelButton = styled.button`
// // //   width: 100%;
// // //   padding: 16px;
// // //   background: transparent;
// // //   border: 2px solid #64748b;
// // //   border-radius: 50px;
// // //   color: #64748b;
// // //   font-size: 1.1rem;
// // //   font-weight: 700;
// // //   cursor: pointer;
// // //   margin-top: 10px;

// // //   &:hover {
// // //     background: #f1f5f9;
// // //   }
// // // `;

// // // const ErrorMsg = styled.div`
// // //   background-color: #fef2f2;
// // //   color: #dc2626;
// // //   padding: 12px 16px;
// // //   border-radius: 10px;
// // //   font-size: 14px;
// // //   margin-bottom: 20px;
// // //   border: 1px solid #fee2e2;
// // // `;

// // // /* ================= MAIN COMPONENT ================= */
// // // const Login = ({ setUser }) => {
// // //   const [username, setUsername] = useState('');
// // //   const [password, setPassword] = useState('');
// // //   const [selectedRole, setSelectedRole] = useState('staff'); 
// // //   const [loading, setLoading] = useState(false);
// // //   const [error, setError] = useState('');
// // //   const [showPassword, setShowPassword] = useState(false);
  
// // //   const [showLeadForm, setShowLeadForm] = useState(false);
// // // const [targetRoute, setTargetRoute] = useState("");

// // // const [leadData, setLeadData] = useState({
// // //   fullName: "",
// // //   email: "",
// // //   phone: "",
// // // });

// // // const [emailOnly, setEmailOnly] = useState(false);
// // //   const navigate = useNavigate();
// // //   const handleProtectedNavigation = (route) => {
// // //   setTargetRoute(route);
// // //   setShowLeadForm(true);
// // // };

// // // const submitLead = async (e) => {
// // //   e.preventDefault();
// // //   try {
// // //     // 1. Create a user object from the form data
// // //     const userData = { 
// // //       name: leadData.fullName || "Guest", 
// // //       email: leadData.email, 
// // //       role: selectedRole // from your existing state
// // //     };
    
// // //     // 2. Call setUser (this was passed as a prop from App.js)
// // //     // This updates the React state AND saves the user to localStorage
// // //     setUser(userData);
    
// // //     // 3. Set a dummy token so isAuthenticated() evaluates to true
// // //     localStorage.setItem("token", "your-auth-token-here");

// // //     // 4. Close the modal and navigate
// // //     setShowLeadForm(false);
// // //     navigate(targetRoute || "/dashboard"); 

// // //   } catch (error) {
// // //     console.error("Lead submission error:", error);
// // //     navigate(targetRoute || "/dashboard");
// // //   }
// // // };

// // // // const submitLead = async (e) => {
// // // //     e.preventDefault();
// // // //     try {

// // // //       navigate(targetRoute || "/dashboard"); // fallback to dashboard
// // // //     } catch (error) {
// // // //       console.error("Lead submission error:", error);
// // // //       // Still navigate even if API fails (optional)
// // // //       navigate(targetRoute || "/dashboard");
// // // //     }
// // // //   };

// // // const cancelLeadForm = () => {
// // //     setShowLeadForm(false);
// // //     setLeadData({ fullName: "", email: "", phone: "" });
// // //   };

// // //   return (
// // //     <LoginContainer>
// // //       {/* Background Video */}
// // // <BackgroundVideo autoPlay loop playsInline>
// // //         <source 
// // //           src="https://cdn1.kingschat.online/uploads/media/57fbe8f538da4d5569ad1cff/ODVSNjB0SS9PQlhUakxuQm5Zc0ZpUT09/808133.mp4" 
// // //           type="video/mp4" 
// // //         />
// // //         Your browser does not support the video tag.
// // //       </BackgroundVideo>

// // //       {/* Dark Overlay */}
// // //       <Overlay />

// // //       {/* Header */}
// // //       <Header>
// // //         <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
// // // <img
// // //   src={logo}
// // //   alt="SPIRITMAN Online"
// // //   style={{
// // //     width: 120,
// // //     height: "auto",
// // //     objectFit: "contain",
// // //   }}
// // // />
// // //         </div>

// // // <Nav>
// // //           <NavLink onClick={() => handleProtectedNavigation("/dashboard")}>HOME</NavLink>
// // //           <NavLink onClick={() => navigate("/about")}>About Us</NavLink>
// // //           <NavLink onClick={() => handleProtectedNavigation("/resources")}>Download Resource</NavLink>
// // //         </Nav>

// // // <HeaderRight>
// // //   <a
// // //     href="https://kingschat.online/user/spiritman.online"
// // //     target="_blank"
// // //     rel="noopener noreferrer"
// // //     style={{ textDecoration: "none" }}
// // //   >
// // //     <div
// // //       style={{
// // //         display: "flex",
// // //         alignItems: "center",
// // //         gap: "6px",
// // //         background: "#2360ff",
// // //         color: "#fff",
// // //         padding: "8px 14px",
// // //         borderRadius: "999px",
// // //         fontWeight: "700",
// // //         cursor: "pointer",
// // //         transition: "0.3s",
// // //         boxShadow: "0 3px 10px rgba(35,96,255,.25)",
// // //       }}
// // //     >
// // //       <ExternalLink size={16} />
// // //       <span>Follow us on KingsChat</span>
// // //     </div>
// // //   </a>

// // //   <a
// // //     href="https://wa.link/ss0tjf"
// // //     target="_blank"
// // //     rel="noopener noreferrer"
// // //     style={{ textDecoration: "none", marginTop: "10px", display: "inline-block" }}
// // //   >
// // //     <div
// // //       style={{
// // //         display: "flex",
// // //         alignItems: "center",
// // //         gap: "6px",
// // //         background: "#25D366",
// // //         color: "#fff",
// // //         padding: "8px 14px",
// // //         borderRadius: "999px",
// // //         fontWeight: "700",
// // //         cursor: "pointer",
// // //         transition: "0.3s",
// // //         boxShadow: "0 3px 10px rgba(37,211,102,.25)",
// // //       }}
// // //     >
// // //       <MessageCircle size={16} />
// // //       <span>Contact us</span>
// // //     </div>
// // //   </a>
// // // </HeaderRight>
// // //       </Header>

// // //       <MainContent>
// // //         <HeroSection>
// // //           <HeraldLogo>SPIRITMAN</HeraldLogo>
// // //           <SubtitleText>Global Missions • AI for Church Growth • AI for Business</SubtitleText>
// // //           <Tagline>Join us in this mandate, reaching the last lost soul.</Tagline>

// // //           <ButtonsContainer>
// // //   <BecomeButton
// // //   onClick={() =>
// // //     handleProtectedNavigation("/evangelist")
// // //   }
// // // >
// // //   Become a DIGITAL EVANGELIST
// // // </BecomeButton>

// // // <SignInButton
// // //   onClick={() =>
// // //     handleProtectedNavigation("/resources")
// // //   }
// // // >
// // //   Access our Resource
// // // </SignInButton>
// // //           </ButtonsContainer>
// // //         </HeroSection>

// // //       </MainContent>
// // //       {showLeadForm && (
// // //   <ModalOverlay>
// // //     <ModalCard>
// // //       <h2>Stay Connected</h2>

// // //       <p>
// // //         Kindly provide your details before
// // //         proceeding.
// // //       </p>

// // //       <Form onSubmit={submitLead}>
// // //         {!emailOnly && (
// // //           <>
// // //             <FormGroup>
// // //               <Label>Full Name</Label>
// // //               <Input
// // //                 value={leadData.fullName}
// // //                 onChange={(e) =>
// // //                   setLeadData({
// // //                     ...leadData,
// // //                     fullName: e.target.value,
// // //                   })
// // //                 }
// // //               />
// // //             </FormGroup>

// // //             <FormGroup>
// // //               <Label>Phone Number</Label>
// // //               <Input
// // //                 value={leadData.phone}
// // //                 onChange={(e) =>
// // //                   setLeadData({
// // //                     ...leadData,
// // //                     phone: e.target.value,
// // //                   })
// // //                 }
// // //               />
// // //             </FormGroup>
// // //           </>
// // //         )}

// // //         <FormGroup>
// // //           <Label>Email Address</Label>
// // //           <Input
// // //             type="email"
// // //             required
// // //             value={leadData.email}
// // //             onChange={(e) =>
// // //               setLeadData({
// // //                 ...leadData,
// // //                 email: e.target.value,
// // //               })
// // //             }
// // //           />
// // //         </FormGroup>

// // //         <div
// // //           style={{
// // //             marginBottom: 20,
// // //           }}
// // //         >
// // //           <input
// // //             type="checkbox"
// // //             checked={emailOnly}
// // //             onChange={() =>
// // //               setEmailOnly(!emailOnly)
// // //             }
// // //           />{" "}
// // //           Email only
// // //         </div>

// // // <SubmitButton type="submit">Continue</SubmitButton>
// // //         <CancelButton type="button" onClick={cancelLeadForm}>
// // //                 Cancel
// // //               </CancelButton>
// // //       </Form>
// // //     </ModalCard>
// // //   </ModalOverlay>
// // // )}
// // //     </LoginContainer>
// // //   );
// // // };

// // // export default Login;

// // // //BackgroundVideo









// // import React, { useState } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import styled from 'styled-components';
// // import { FaEye, FaEyeSlash } from "react-icons/fa";
// // import { MessageCircle, ExternalLink, Menu, X } from "lucide-react";
// // import api from '../api';
// // import LogoImg from "./assets/performance_logo.png";
// // import logo from "../assets/SpitMan.jpeg"; // SPIRITMAN logo

// // /* ================= STYLED COMPONENTS ================= */
// // const LoginContainer = styled.div`
// //   position: relative;
// //   min-height: 100vh;
// //   overflow: hidden;
// //   color: white;
// //   display: flex;
// //   flex-direction: column;
// //   font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
// // `;

// // const BackgroundVideo = styled.video`
// //   position: absolute;
// //   top: 0;
// //   left: 0;
// //   width: 100%;
// //   height: 100%;
// //   object-fit: cover;
// //   z-index: -2;
// // `;

// // const Overlay = styled.div`
// //   position: absolute;
// //   top: 0;
// //   left: 0;
// //   width: 100%;
// //   height: 100%;
// //   ${'' /* background: linear-gradient(
// //     to bottom,
// //     rgba(15, 23, 42, 0.75),
// //     rgba(15, 23, 42, 0.85)
// //   ); */}
// //   z-index: -1;
// // `;

// // const Header = styled.header`
// //   background: rgba(15, 23, 42, 0.95);
// //   backdrop-filter: blur(12px);
// //   padding: 16px 24px;
// //   display: flex;
// //   justify-content: space-between;
// //   align-items: center;
// //   position: fixed;
// //   width: 100%;
// //   z-index: 1000;
// //   border-bottom: 1px solid rgba(255,255,255,0.1);
  
// //   @media (max-width: 768px) {
// //     padding: 14px 20px;
// //   }
// // `;

// // const LogoContainer = styled.div`
// //   display: flex;
// //   align-items: center;
// //   gap: 12px;
// //   cursor: pointer;
// // `;

// // const BrandLogo = styled.img`
// //   width: 100px;
// //   height: 100px;
// //   object-fit: contain;
// //   border-radius: 8px;
// // `;

// // const BrandName = styled.div`
// //   font-size: 1.65rem;
// //   font-weight: 800;
// //   letter-spacing: -0.5px;
// //   background: linear-gradient(90deg, #fff, #e0f2fe);
// //   -webkit-background-clip: text;
// //   -webkit-text-fill-color: transparent;
// // `;

// // const Nav = styled.nav`
// //   display: flex;
// //   gap: 40px;
// //   align-items: center;
  
// //   @media (max-width: 768px) {
// //     display: none;
// //   }
// // `;

// // const NavLink = styled.a`
// //   color: white;
// //   text-decoration: none;
// //   font-weight: 600;
// //   font-size: 0.95rem;
// //   letter-spacing: 0.5px;
// //   position: relative;
// //   transition: color 0.3s ease;
  
// //   &:hover {
// //     color: #a5b4fc;
// //   }
  
// //   &::after {
// //     content: '';
// //     position: absolute;
// //     width: 0;
// //     height: 2px;
// //     bottom: -4px;
// //     left: 0;
// //     background: #6366f1;
// //     transition: width 0.3s ease;
// //   }
  
// //   &:hover::after {
// //     width: 100%;
// //   }
// // `;

// // const MobileMenuButton = styled.button`
// //   display: none;
// //   background: none;
// //   border: none;
// //   color: white;
// //   cursor: pointer;
// //   padding: 8px;
  
// //   @media (max-width: 768px) {
// //     display: flex;
// //     align-items: center;
// //     justify-content: center;
// //   }
// // `;

// // const MobileNav = styled.div`
// //   display: ${props => props.isOpen ? 'flex' : 'none'};
// //   position: fixed;
// //   top: 70px;
// //   left: 0;
// //   right: 0;
// //   background: rgba(15, 23, 42, 0.98);
// //   backdrop-filter: blur(12px);
// //   flex-direction: column;
// //   padding: 24px;
// //   gap: 20px;
// //   z-index: 999;
// //   border-bottom: 1px solid rgba(255,255,255,0.1);
// // `;

// // const HeaderRight = styled.div`
// //   display: flex;
// //   align-items: center;
// //   gap: 12px;
  
// //   @media (max-width: 768px) {
// //     gap: 8px;
// //   }
// // `;

// // const SocialButton = styled.a`
// //   display: flex;
// //   align-items: center;
// //   gap: 8px;
// //   padding: 10px 18px;
// //   border-radius: 9999px;
// //   font-weight: 700;
// //   font-size: 0.9rem;
// //   text-decoration: none;
// //   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
// //   cursor: pointer;
// //   white-space: nowrap;
  
// //   &:hover {
// //     transform: translateY(-2px);
// //     box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.2);
// //   }
// // `;

// // const KingsChatButton = styled(SocialButton)`
// //   background: #fff;
// //   color: #2360ff;
  
// //   &:hover {
// //     background: #1e55e0;
// //   }
// // `;

// // const ContactButton = styled(SocialButton)`
// //   background: #25D366;
// //   color: white;
  
// //   &:hover {
// //     background: #22c55e;
// //   }
// // `;

// // const MainContent = styled.main`
// //   flex: 1;
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   padding-top: 90px;
// //   position: relative;
// //   z-index: 10;
// //   padding-bottom: 60px;
// // `;

// // const HeroSection = styled.div`
// //   text-align: center;
// //   max-width: 960px;
// //   padding: 0 24px;
// //   background: rgba(15, 23, 42, 0.65);
// //   backdrop-filter: blur(16px);
// //   border: 1px solid rgba(255,255,255,0.1);
// //   border-radius: 28px;
// //   padding: 64px 48px;
// //   box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.4);
  
// //   @media (max-width: 768px) {
// //     padding: 48px 24px;
// //     margin: 16px;
// //     border-radius: 20px;
// //   }
// // `;

// // const HeraldLogo = styled.h1`
// //   font-size: 4.5rem;
// //   font-weight: 900;
// //   letter-spacing: -3px;
// //   margin-bottom: 16px;
// //   background: linear-gradient(90deg, #f1f5f9, #e0f2fe, #c7d2fe);
// //   -webkit-background-clip: text;
// //   -webkit-text-fill-color: transparent;
// //   line-height: 1;
  
// //   @media (max-width: 768px) {
// //     font-size: 3.2rem;
// //   }
// // `;

// // const SubtitleText = styled.p`
// //   font-size: 1.45rem;
// //   margin-bottom: 12px;
// //   font-weight: 600;
// //   color: #e0f2fe;
// //   line-height: 1.4;
  
// //   @media (max-width: 768px) {
// //     font-size: 1.25rem;
// //   }
// // `;

// // const Tagline = styled.p`
// //   font-size: 1.2rem;
// //   color: #bae6fd;
// //   max-width: 620px;
// //   margin: 0 auto 48px;
// //   line-height: 1.5;
  
// //   @media (max-width: 768px) {
// //     font-size: 1.1rem;
// //     margin-bottom: 36px;
// //   }
// // `;

// // const ButtonsContainer = styled.div`
// //   display: flex;
// //   gap: 20px;
// //   justify-content: center;
// //   flex-wrap: wrap;
  
// //   @media (max-width: 768px) {
// //     flex-direction: column;
// //     align-items: center;
// //     gap: 16px;
// //   }
// // `;

// // const PrimaryButton = styled.button`
// //   padding: 18px 52px;
// //   background: linear-gradient(90deg, #6366f1, #4f46e5);
// //   color: white;
// //   border: none;
// //   border-radius: 9999px;
// //   font-size: 1.15rem;
// //   font-weight: 700;
// //   cursor: pointer;
// //   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
// //   box-shadow: 0 10px 15px -3px rgba(99, 102, 241, 0.4);
  
// //   &:hover {
// //     transform: translateY(-4px) scale(1.02);
// //     box-shadow: 0 20px 25px -5px rgba(99, 102, 241, 0.5);
// //   }
// // `;

// // const SecondaryButton = styled.button`
// //   padding: 18px 52px;
// //   background: rgba(255,255,255,0.12);
// //   color: white;
// //   border: 2px solid rgba(255,255,255,0.5);
// //   border-radius: 9999px;
// //   font-size: 1.15rem;
// //   font-weight: 700;
// //   cursor: pointer;
// //   backdrop-filter: blur(8px);
// //   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
// //   &:hover {
// //     background: rgba(255,255,255,0.2);
// //     border-color: rgba(255,255,255,0.9);
// //     transform: translateY(-2px);
// //   }
// // `;

// // /* Modal Styles */
// // const ModalOverlay = styled.div`
// //   position: fixed;
// //   inset: 0;
// //   background: rgba(0,0,0,0.8);
// //   display: flex;
// //   justify-content: center;
// //   align-items: center;
// //   z-index: 2000;
// //   padding: 20px;
// // `;

// // const ModalCard = styled.div`
// //   background: white;
// //   width: 100%;
// //   max-width: 460px;
// //   border-radius: 24px;
// //   padding: 40px;
// //   color: #0f172a;
// //   box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  
// //   @media (max-width: 640px) {
// //     padding: 32px 24px;
// //   }
// // `;

// // /* Form Styles */
// // const Logo = styled.img`
// //   width: 140px;
// //   margin-bottom: 24px;
// // `;

// // const Title = styled.h2`
// //   color: #0f172a;
// //   font-weight: 800;
// //   margin-bottom: 8px;
// //   font-size: 2rem;
// // `;

// // const Subtitle = styled.p`
// //   color: #64748b;
// //   margin-bottom: 32px;
// // `;

// // const Form = styled.form``;

// // const FormGroup = styled.div`
// //   margin-bottom: 20px;
// //   text-align: left;
// // `;

// // const Label = styled.label`
// //   display: block;
// //   color: #1e293b;
// //   margin-bottom: 8px;
// //   font-size: 14px;
// //   font-weight: 700;
// // `;

// // const Input = styled.input`
// //   width: 100%;
// //   padding: 15px 18px;
// //   border: 2px solid #e2e8f0;
// //   border-radius: 14px;
// //   font-size: 16px;
// //   transition: all 0.2s ease;
// //   box-sizing: border-box;
  
// //   &:focus {
// //     outline: none;
// //     border-color: #6366f1;
// //     box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.15);
// //   }
// // `;

// // const PasswordInputWrapper = styled.div`
// //   position: relative;
// // `;

// // const EyeButton = styled.button`
// //   position: absolute;
// //   right: 18px;
// //   top: 50%;
// //   transform: translateY(-50%);
// //   background: none;
// //   border: none;
// //   color: #64748b;
// //   font-size: 20px;
// //   cursor: pointer;
// // `;

// // const SubmitButton = styled.button`
// //   width: 100%;
// //   padding: 16px;
// //   background: linear-gradient(90deg, #1e40af, #1e3a8a);
// //   border: none;
// //   border-radius: 9999px;
// //   color: white;
// //   font-size: 1.1rem;
// //   font-weight: 700;
// //   cursor: pointer;
// //   margin-top: 12px;
// //   transition: all 0.3s;
  
// //   &:hover {
// //     transform: translateY(-2px);
// //   }
// // `;

// // const CancelButton = styled.button`
// //   width: 100%;
// //   padding: 16px;
// //   background: transparent;
// //   border: 2px solid #64748b;
// //   border-radius: 9999px;
// //   color: #64748b;
// //   font-size: 1.1rem;
// //   font-weight: 700;
// //   cursor: pointer;
// //   margin-top: 12px;
  
// //   &:hover {
// //     background: #f8fafc;
// //   }
// // `;

// // const ErrorMsg = styled.div`
// //   background-color: #fef2f2;
// //   color: #dc2626;
// //   padding: 14px 18px;
// //   border-radius: 12px;
// //   font-size: 14px;
// //   margin-bottom: 24px;
// //   border: 1px solid #fecaca;
// // `;

// // /* ================= MAIN COMPONENT ================= */
// // const Login = ({ setUser }) => {
// //   const [username, setUsername] = useState('');
// //   const [password, setPassword] = useState('');
// //   const [selectedRole, setSelectedRole] = useState('staff');
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState('');
// //   const [showPassword, setShowPassword] = useState(false);
  
// //   const [showLeadForm, setShowLeadForm] = useState(false);
// //   const [targetRoute, setTargetRoute] = useState("");
// //   const [leadData, setLeadData] = useState({
// //     fullName: "",
// //     email: "",
// //     phone: "",
// //   });
// //   const [emailOnly, setEmailOnly] = useState(false);
// //   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

// //   const navigate = useNavigate();

// //   const handleProtectedNavigation = (route) => {
// //     setTargetRoute(route);
// //     setShowLeadForm(true);
// //     setIsMobileMenuOpen(false);
// //   };

// //   const submitLead = async (e) => {
// //     e.preventDefault();
// //     try {
// //       const userData = {
// //         name: leadData.fullName || "Guest",
// //         email: leadData.email,
// //         role: selectedRole
// //       };
      
// //       setUser(userData);
// //       localStorage.setItem("token", "your-auth-token-here");
      
// //       setShowLeadForm(false);
// //       navigate(targetRoute || "/dashboard");
// //     } catch (error) {
// //       console.error("Lead submission error:", error);
// //       navigate(targetRoute || "/dashboard");
// //     }
// //   };

// //   const cancelLeadForm = () => {
// //     setShowLeadForm(false);
// //     setLeadData({ fullName: "", email: "", phone: "" });
// //     setEmailOnly(false);
// //   };

// //   return (
// //     <LoginContainer>
// //       {/* Background Video */}
// //       <BackgroundVideo autoPlay loop muted playsInline>
// //         <source
// //           src="https://cdn1.kingschat.online/uploads/media/57fbe8f538da4d5569ad1cff/ODVSNjB0SS9PQlhUakxuQm5Zc0ZpUT09/808133.mp4"
// //           type="video/mp4"
// //         />
// //       </BackgroundVideo>
      
// //       <Overlay />

// //       {/* Header */}
// //       <Header>
// //         <LogoContainer onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
// //           <BrandLogo src={logo} alt="SPIRITMAN" />
// //           {/* <BrandName>SPIRITMAN</BrandName> */}
// //         </LogoContainer>

// //         <Nav>
// //           <NavLink onClick={() => handleProtectedNavigation("/dashboard")}>HOME</NavLink>
// //           <NavLink onClick={() => navigate("/about")}>About Us</NavLink>
// //           <NavLink onClick={() => handleProtectedNavigation("/resources")}>Resources</NavLink>
// //         </Nav>

// //         <HeaderRight>
// //           <KingsChatButton
// //             href="https://kingschat.online/user/spiritman.online"
// //             target="_blank"
// //             rel="noopener noreferrer"
// //           >
// //             <img 
// //               src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/VnBZbVVyUXBXNGE3R1lmVmVlZWJQQT09/kingsch.jpg" 
// //               alt="KingsChat" 
// //               style={{ width: '20px', height: '20px' }}
// //             />
// //             <span>KingsChat</span>
// //           </KingsChatButton>

// //           <ContactButton
// //             href="https://wa.link/ss0tjf"
// //             target="_blank"
// //             rel="noopener noreferrer"
// //           >
// //             <MessageCircle size={18} />
// //             <span>What App</span>
// //           </ContactButton>

// //           <MobileMenuButton onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
// //             {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
// //           </MobileMenuButton>
// //         </HeaderRight>
// //       </Header>

// //       {/* Mobile Navigation */}
// //       <MobileNav isOpen={isMobileMenuOpen}>
// //         <NavLink onClick={() => handleProtectedNavigation("/dashboard")}>HOME</NavLink>
// //         <NavLink onClick={() => navigate("/about")}>About Us</NavLink>
// //         <NavLink onClick={() => handleProtectedNavigation("/resources")}>Resources</NavLink>
// //       </MobileNav>

// //       <MainContent>
// //         <HeroSection>
// //           <HeraldLogo>SPIRITMAN</HeraldLogo>
// //           <SubtitleText>Global Missions • AI for Church Growth • AI for Kingdom Business</SubtitleText>
// //           <Tagline>
// //             Empowering the Church with technology. Reaching the last lost soul through digital evangelism.
// //           </Tagline>
          
// //           <ButtonsContainer>
// //             <PrimaryButton
// //               onClick={() => handleProtectedNavigation("/evangelist")}
// //             >
// //               Become a DIGITAL EVANGELIST
// //             </PrimaryButton>
            
// //             <SecondaryButton
// //               onClick={() => handleProtectedNavigation("/resources")}
// //             >
// //               Access Resources
// //             </SecondaryButton>
// //           </ButtonsContainer>
// //         </HeroSection>
// //       </MainContent>

// //       {/* Lead Capture Modal */}
// //       {showLeadForm && (
// //         <ModalOverlay>
// //           <ModalCard>
// //             <h2 style={{ marginBottom: '8px', fontSize: '1.75rem' }}>Stay Connected</h2>
// //             <p style={{ color: '#64748b', marginBottom: '32px' }}>
// //               Kindly provide your details before proceeding.
// //             </p>
            
// //             <Form onSubmit={submitLead}>
// //               {!emailOnly && (
// //                 <>
// //                   <FormGroup>
// //                     <Label>Full Name</Label>
// //                     <Input
// //                       value={leadData.fullName}
// //                       onChange={(e) => setLeadData({ ...leadData, fullName: e.target.value })}
// //                       placeholder="John Doe"
// //                     />
// //                   </FormGroup>
                  
// //                   <FormGroup>
// //                     <Label>Phone Number</Label>
// //                     <Input
// //                       value={leadData.phone}
// //                       onChange={(e) => setLeadData({ ...leadData, phone: e.target.value })}
// //                       placeholder="+234 801 234 5678"
// //                     />
// //                   </FormGroup>
// //                 </>
// //               )}
              
// //               <FormGroup>
// //                 <Label>Email Address</Label>
// //                 <Input
// //                   type="email"
// //                   required
// //                   value={leadData.email}
// //                   onChange={(e) => setLeadData({ ...leadData, email: e.target.value })}
// //                   placeholder="you@example.com"
// //                 />
// //               </FormGroup>

// //               <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '28px', cursor: 'pointer' }}>
// //                 <input
// //                   type="checkbox"
// //                   checked={emailOnly}
// //                   onChange={() => setEmailOnly(!emailOnly)}
// //                 />
// //                 <span style={{ fontSize: '0.95rem', color: '#475569' }}>Email only</span>
// //               </label>

// //               <SubmitButton type="submit">Continue</SubmitButton>
// //               <CancelButton type="button" onClick={cancelLeadForm}>
// //                 Cancel
// //               </CancelButton>
// //             </Form>
// //           </ModalCard>
// //         </ModalOverlay>
// //       )}
// //     </LoginContainer>
// //   );
// // };

// // export default Login;


// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { MessageCircle, ExternalLink, Menu, X } from "lucide-react";
// import api from '../api';
// import LogoImg from "./assets/performance_logo.png";
// import logo from "../assets/SpitMan.jpeg"; // SPIRITMAN logo

// /* ================= STYLED COMPONENTS ================= */
// const LoginContainer = styled.div`
//   position: relative;
//   min-height: 100vh;
//   overflow: hidden;
//   color: white;
//   display: flex;
//   flex-direction: column;
//   font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
// `;

// const BackgroundVideo = styled.video`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   z-index: -2;
// `;

// const Overlay = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   z-index: -1;
// `;

// const Header = styled.header`
//   background: rgba(15, 23, 42, 0.95);
//   backdrop-filter: blur(12px);
//   padding: 12px 20px;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   position: fixed;
//   width: 100%;
//   z-index: 1000;
//   border-bottom: 1px solid rgba(255,255,255,0.1);
//   flex-wrap: wrap;
  
//   @media (max-width: 768px) {
//     padding: 10px 12px;
//     flex-wrap: nowrap;
//     gap: 6px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 8px 10px;
//     gap: 4px;
//   }
// `;

// const LogoContainer = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   cursor: pointer;
//   flex-shrink: 0;
  
//   @media (max-width: 768px) {
//     gap: 6px;
//   }
  
//   @media (max-width: 480px) {
//     gap: 4px;
//   }
// `;

// const BrandLogo = styled.img`
//   width: 120px;
//   height: 50px;
//   object-fit: contain;
//   border-radius: 8px;
  
//   @media (max-width: 768px) {
//     width: 100px;
//     height: 40px;
//   }
  
//   @media (max-width: 480px) {
//     width: 100px;
//     height: 40px;
//   }
// `;

// const BrandName = styled.div`
//   font-size: 1.65rem;
//   font-weight: 800;
//   letter-spacing: -0.5px;
//   background: linear-gradient(90deg, #fff, #e0f2fe);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
// `;

// const Nav = styled.nav`
//   display: flex;
//   gap: 40px;
//   align-items: center;
  
//   @media (max-width: 768px) {
//     display: none;
//   }
// `;

// const NavLink = styled.a`
//   color: white;
//   text-decoration: none;
//   font-weight: 600;
//   font-size: 0.95rem;
//   letter-spacing: 0.5px;
//   position: relative;
//   transition: color 0.3s ease;
//   cursor: pointer;
  
//   &:hover {
//     color: #a5b4fc;
//   }
  
//   &::after {
//     content: '';
//     position: absolute;
//     width: 0;
//     height: 2px;
//     bottom: -4px;
//     left: 0;
//     background: #6366f1;
//     transition: width 0.3s ease;
//   }
  
//   &:hover::after {
//     width: 100%;
//   }
// `;

// const MobileMenuButton = styled.button`
//   display: none;
//   background: none;
//   border: none;
//   color: white;
//   cursor: pointer;
//   padding: 4px;
//   margin-left: 2px;
//   flex-shrink: 0;
  
//   @media (max-width: 768px) {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }
// `;

// const MobileNav = styled.div`
//   display: ${props => props.isOpen ? 'flex' : 'none'};
//   position: fixed;
//   top: ${props => props.headerHeight || '70px'};
//   left: 0;
//   right: 0;
//   background: rgba(15, 23, 42, 0.98);
//   backdrop-filter: blur(12px);
//   flex-direction: column;
//   padding: 24px 20px;
//   gap: 16px;
//   z-index: 999;
//   border-bottom: 1px solid rgba(255,255,255,0.1);
//   max-height: calc(100vh - ${props => props.headerHeight || '70px'});
//   overflow-y: auto;
  
//   @media (max-width: 768px) {
//     padding: 20px 16px;
//     gap: 14px;
//   }
// `;

// const MobileNavLink = styled(NavLink)`
//   padding: 12px 16px;
//   border-radius: 8px;
//   font-size: 1.1rem;
//   width: 100%;
//   text-align: center;
//   border-bottom: 1px solid rgba(255,255,255,0.05);
  
//   &:hover {
//     background: rgba(255,255,255,0.05);
//   }
  
//   &::after {
//     display: none;
//   }
// `;

// const HeaderRight = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   flex-shrink: 1;
//   min-width: 0;
  
//   @media (max-width: 768px) {
//     gap: 4px;
//     flex: 1;
//     justify-content: flex-end;
//   }
  
//   @media (max-width: 480px) {
//     gap: 3px;
//   }
// `;

// const SocialButton = styled.a`
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   padding: 8px 14px;
//   border-radius: 9999px;
//   font-weight: 700;
//   font-size: 0.85rem;
//   text-decoration: none;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   cursor: pointer;
//   white-space: nowrap;
//   flex-shrink: 1;
//   min-width: 0;
  
//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.2);
//   }
  
//   @media (max-width: 768px) {
//     padding: 5px 10px;
//     font-size: 0.7rem;
//     gap: 4px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 4px 8px;
//     font-size: 0.6rem;
//     gap: 3px;
//   }
// `;

// const KingsChatButton = styled(SocialButton)`
//   background: #fff;
//   color: #2360ff;
  
//   &:hover {
//     background: #1e55e0;
//     color: white;
//   }
// `;

// const ContactButton = styled(SocialButton)`
//   background: #25D366;
//   color: white;
  
//   &:hover {
//     background: #22c55e;
//   }
// `;

// const SocialIcon = styled.img`
//   width: 18px;
//   height: 18px;
//   flex-shrink: 0;
  
//   @media (max-width: 768px) {
//     width: 14px;
//     height: 14px;
//   }
  
//   @media (max-width: 480px) {
//     width: 12px;
//     height: 12px;
//   }
// `;

// const SocialText = styled.span`
//   display: inline;
  
//   @media (max-width: 480px) {
//     font-size: 0.55rem;
//   }
// `;

// const MainContent = styled.main`
//   flex: 1;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding-top: 80px;
//   position: relative;
//   z-index: 10;
//   padding-bottom: 60px;
  
//   @media (max-width: 768px) {
//     padding-top: 70px;
//   }
// `;

// const HeroSection = styled.div`
//   text-align: center;
//   max-width: 960px;
//   padding: 0 24px;
//   background: rgba(15, 23, 42, 0.65);
//   backdrop-filter: blur(16px);
//   border: 1px solid rgba(255,255,255,0.1);
//   border-radius: 28px;
//   padding: 64px 48px;
//   box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.4);
  
//   @media (max-width: 768px) {
//     padding: 32px 20px;
//     margin: 16px;
//     border-radius: 20px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 24px 16px;
//     margin: 12px;
//   }
// `;

// const HeraldLogo = styled.h1`
//   font-size: 4.5rem;
//   font-weight: 900;
//   letter-spacing: -3px;
//   margin-bottom: 16px;
//   background: linear-gradient(90deg, #f1f5f9, #e0f2fe, #c7d2fe);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   line-height: 1;
  
//   @media (max-width: 768px) {
//     font-size: 3rem;
//   }
  
//   @media (max-width: 480px) {
//     font-size: 2.5rem;
//   }
// `;

// const SubtitleText = styled.p`
//   font-size: 1.45rem;
//   margin-bottom: 12px;
//   font-weight: 600;
//   color: #e0f2fe;
//   line-height: 1.4;
  
//   @media (max-width: 768px) {
//     font-size: 1.1rem;
//   }
  
//   @media (max-width: 480px) {
//     font-size: 0.95rem;
//   }
// `;

// const Tagline = styled.p`
//   font-size: 1.2rem;
//   color: #bae6fd;
//   max-width: 620px;
//   margin: 0 auto 48px;
//   line-height: 1.5;
  
//   @media (max-width: 768px) {
//     font-size: 1rem;
//     margin-bottom: 32px;
//   }
  
//   @media (max-width: 480px) {
//     font-size: 0.9rem;
//     margin-bottom: 24px;
//   }
// `;

// const ButtonsContainer = styled.div`
//   display: flex;
//   gap: 20px;
//   justify-content: center;
//   flex-wrap: wrap;
  
//   @media (max-width: 768px) {
//     flex-direction: column;
//     align-items: center;
//     gap: 12px;
//   }
// `;

// const PrimaryButton = styled.button`
//   padding: 16px 40px;
//   background: linear-gradient(90deg, #6366f1, #4f46e5);
//   color: white;
//   border: none;
//   border-radius: 9999px;
//   font-size: 1.05rem;
//   font-weight: 700;
//   cursor: pointer;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   box-shadow: 0 10px 15px -3px rgba(99, 102, 241, 0.4);
  
//   &:hover {
//     transform: translateY(-4px) scale(1.02);
//     box-shadow: 0 20px 25px -5px rgba(99, 102, 241, 0.5);
//   }
  
//   @media (max-width: 768px) {
//     padding: 14px 32px;
//     font-size: 0.95rem;
//     width: 100%;
//     max-width: 320px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 12px 24px;
//     font-size: 0.9rem;
//     max-width: 280px;
//   }
// `;

// const SecondaryButton = styled.button`
//   padding: 16px 40px;
//   background: rgba(255,255,255,0.12);
//   color: white;
//   border: 2px solid rgba(255,255,255,0.5);
//   border-radius: 9999px;
//   font-size: 1.05rem;
//   font-weight: 700;
//   cursor: pointer;
//   backdrop-filter: blur(8px);
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
//   &:hover {
//     background: rgba(255,255,255,0.2);
//     border-color: rgba(255,255,255,0.9);
//     transform: translateY(-2px);
//   }
  
//   @media (max-width: 768px) {
//     padding: 14px 32px;
//     font-size: 0.95rem;
//     width: 100%;
//     max-width: 320px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 12px 24px;
//     font-size: 0.9rem;
//     max-width: 280px;
//   }
// `;

// /* Modal Styles */
// const ModalOverlay = styled.div`
//   position: fixed;
//   inset: 0;
//   background: rgba(0,0,0,0.8);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index: 2000;
//   padding: 20px;
// `;

// const ModalCard = styled.div`
//   background: white;
//   width: 100%;
//   max-width: 460px;
//   border-radius: 24px;
//   padding: 40px;
//   color: #0f172a;
//   box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  
//   @media (max-width: 640px) {
//     padding: 28px 20px;
//     margin: 16px;
//   }
// `;

// /* Form Styles */
// const Logo = styled.img`
//   width: 140px;
//   margin-bottom: 24px;
// `;

// const Title = styled.h2`
//   color: #0f172a;
//   font-weight: 800;
//   margin-bottom: 8px;
//   font-size: 2rem;
// `;

// const Subtitle = styled.p`
//   color: #64748b;
//   margin-bottom: 32px;
// `;

// const Form = styled.form``;

// const FormGroup = styled.div`
//   margin-bottom: 20px;
//   text-align: left;
// `;

// const Label = styled.label`
//   display: block;
//   color: #1e293b;
//   margin-bottom: 8px;
//   font-size: 14px;
//   font-weight: 700;
// `;

// const Input = styled.input`
//   width: 100%;
//   padding: 15px 18px;
//   border: 2px solid #e2e8f0;
//   border-radius: 14px;
//   font-size: 16px;
//   transition: all 0.2s ease;
//   box-sizing: border-box;
  
//   &:focus {
//     outline: none;
//     border-color: #6366f1;
//     box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.15);
//   }
// `;

// const PasswordInputWrapper = styled.div`
//   position: relative;
// `;

// const EyeButton = styled.button`
//   position: absolute;
//   right: 18px;
//   top: 50%;
//   transform: translateY(-50%);
//   background: none;
//   border: none;
//   color: #64748b;
//   font-size: 20px;
//   cursor: pointer;
// `;

// const SubmitButton = styled.button`
//   width: 100%;
//   padding: 16px;
//   background: linear-gradient(90deg, #1e40af, #1e3a8a);
//   border: none;
//   border-radius: 9999px;
//   color: white;
//   font-size: 1.1rem;
//   font-weight: 700;
//   cursor: pointer;
//   margin-top: 12px;
//   transition: all 0.3s;
  
//   &:hover {
//     transform: translateY(-2px);
//   }
// `;

// const CancelButton = styled.button`
//   width: 100%;
//   padding: 16px;
//   background: transparent;
//   border: 2px solid #64748b;
//   border-radius: 9999px;
//   color: #64748b;
//   font-size: 1.1rem;
//   font-weight: 700;
//   cursor: pointer;
//   margin-top: 12px;
  
//   &:hover {
//     background: #f8fafc;
//   }
// `;

// const ErrorMsg = styled.div`
//   background-color: #fef2f2;
//   color: #dc2626;
//   padding: 14px 18px;
//   border-radius: 12px;
//   font-size: 14px;
//   margin-bottom: 24px;
//   border: 1px solid #fecaca;
// `;

// /* ================= MAIN COMPONENT ================= */
// const Login = ({ setUser }) => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [selectedRole, setSelectedRole] = useState('staff');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
  
//   const [showLeadForm, setShowLeadForm] = useState(false);
//   const [targetRoute, setTargetRoute] = useState("");
//   const [leadData, setLeadData] = useState({
//     fullName: "",
//     email: "",
//     phone: "",
//   });
//   const [emailOnly, setEmailOnly] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [headerHeight, setHeaderHeight] = useState('70px');

//   const navigate = useNavigate();

//   // Get header height for mobile menu positioning
//   React.useEffect(() => {
//     const updateHeaderHeight = () => {
//       const header = document.querySelector('header');
//       if (header) {
//         setHeaderHeight(`${header.offsetHeight}px`);
//       }
//     };
    
//     updateHeaderHeight();
//     window.addEventListener('resize', updateHeaderHeight);
    
//     return () => {
//       window.removeEventListener('resize', updateHeaderHeight);
//     };
//   }, []);

//   const handleProtectedNavigation = (route) => {
//     setTargetRoute(route);
//     setShowLeadForm(true);
//     setIsMobileMenuOpen(false);
//   };

//   const submitLead = async (e) => {
//     e.preventDefault();
//     try {
//       const userData = {
//         name: leadData.fullName || "Guest",
//         email: leadData.email,
//         role: selectedRole
//       };
      
//       setUser(userData);
//       localStorage.setItem("token", "your-auth-token-here");
      
//       setShowLeadForm(false);
//       navigate(targetRoute || "/dashboard");
//     } catch (error) {
//       console.error("Lead submission error:", error);
//       navigate(targetRoute || "/dashboard");
//     }
//   };

//   const cancelLeadForm = () => {
//     setShowLeadForm(false);
//     setLeadData({ fullName: "", email: "", phone: "" });
//     setEmailOnly(false);
//   };

//   return (
//     <LoginContainer>
//       {/* Background Video */}
//       <BackgroundVideo autoPlay loop muted playsInline>
//         <source
//           src="https://cdn1.kingschat.online/uploads/media/57fbe8f538da4d5569ad1cff/ODVSNjB0SS9PQlhUakxuQm5Zc0ZpUT09/808133.mp4"
//           type="video/mp4"
//         />
//       </BackgroundVideo>
      
//       <Overlay />

//       {/* Header */}
//       <Header>
//         <LogoContainer onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
//           <BrandLogo src={logo} alt="SPIRITMAN" />
//         </LogoContainer>

//         <Nav>
//           <NavLink onClick={() => handleProtectedNavigation("/dashboard")}>HOME</NavLink>
//           <NavLink onClick={() => navigate("/about")}>About Us</NavLink>
//           <NavLink onClick={() => handleProtectedNavigation("/resources")}>Resources</NavLink>
//         </Nav>

//         <HeaderRight>
//           <KingsChatButton
//             href="https://kingschat.online/user/spiritman.online"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <SocialIcon 
//               src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/VnBZbVVyUXBXNGE3R1lmVmVlZWJQQT09/kingsch.jpg" 
//               alt="KingsChat" 
//             />
//             <SocialText>KingsChat</SocialText>
//           </KingsChatButton>

//           <ContactButton
//             href="https://wa.link/ss0tjf"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <MessageCircle size={16} />
//             <SocialText>WhatsApp</SocialText>
//           </ContactButton>

//           <MobileMenuButton onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
//             {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
//           </MobileMenuButton>
//         </HeaderRight>
//       </Header>

//       {/* Mobile Navigation */}
//       <MobileNav isOpen={isMobileMenuOpen} headerHeight={headerHeight}>
//         <MobileNavLink onClick={() => handleProtectedNavigation("/dashboard")}>HOME</MobileNavLink>
//         <MobileNavLink onClick={() => navigate("/about")}>About Us</MobileNavLink>
//         <MobileNavLink onClick={() => handleProtectedNavigation("/resources")}>Resources</MobileNavLink>
//       </MobileNav>

//       <MainContent>
//         <HeroSection>
//           <HeraldLogo>SPIRITMAN</HeraldLogo>
//           <SubtitleText>Global Missions • AI for Church Growth • AI for Kingdom Business</SubtitleText>
//           <Tagline>
//             Empowering the Church with technology. Reaching the last lost soul through digital evangelism.
//           </Tagline>
          
//           <ButtonsContainer>
//             <PrimaryButton
//               onClick={() => handleProtectedNavigation("/evangelist")}
//             >
//               Become a DIGITAL EVANGELIST
//             </PrimaryButton>
            
//             <SecondaryButton
//               onClick={() => handleProtectedNavigation("/resources")}
//             >
//               Access Resources
//             </SecondaryButton>
//           </ButtonsContainer>
//         </HeroSection>
//       </MainContent>

//       {/* Lead Capture Modal */}
//       {showLeadForm && (
//         <ModalOverlay>
//           <ModalCard>
//             <h2 style={{ marginBottom: '8px', fontSize: '1.75rem' }}>Stay Connected</h2>
//             <p style={{ color: '#64748b', marginBottom: '32px' }}>
//               Kindly provide your details before proceeding.
//             </p>
            
//             <Form onSubmit={submitLead}>
//               {!emailOnly && (
//                 <>
//                   <FormGroup>
//                     <Label>Full Name</Label>
//                     <Input
//                       value={leadData.fullName}
//                       onChange={(e) => setLeadData({ ...leadData, fullName: e.target.value })}
//                       placeholder="John Doe"
//                     />
//                   </FormGroup>
                  
//                   <FormGroup>
//                     <Label>Phone Number</Label>
//                     <Input
//                       value={leadData.phone}
//                       onChange={(e) => setLeadData({ ...leadData, phone: e.target.value })}
//                       placeholder="+234 801 234 5678"
//                     />
//                   </FormGroup>
//                 </>
//               )}
              
//               <FormGroup>
//                 <Label>Email Address</Label>
//                 <Input
//                   type="email"
//                   required
//                   value={leadData.email}
//                   onChange={(e) => setLeadData({ ...leadData, email: e.target.value })}
//                   placeholder="you@example.com"
//                 />
//               </FormGroup>

//               <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '28px', cursor: 'pointer' }}>
//                 <input
//                   type="checkbox"
//                   checked={emailOnly}
//                   onChange={() => setEmailOnly(!emailOnly)}
//                 />
//                 <span style={{ fontSize: '0.95rem', color: '#475569' }}>Email only</span>
//               </label>

//               <SubmitButton type="submit">Continue</SubmitButton>
//               <CancelButton type="button" onClick={cancelLeadForm}>
//                 Cancel
//               </CancelButton>
//             </Form>
//           </ModalCard>
//         </ModalOverlay>
//       )}
//     </LoginContainer>
//   );
// };

// export default Login;



// import React, { useState, useRef, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
// import { FaEye, FaEyeSlash, FaVolumeMute, FaVolumeUp } from "react-icons/fa";
// import { MessageCircle, ExternalLink, Menu, X } from "lucide-react";
// import api from '../api';
// import LogoImg from "./assets/performance_logo.png";
// import logo from "../assets/SpitMan.jpeg"; // SPIRITMAN logo

// /* ================= STYLED COMPONENTS ================= */
// const LoginContainer = styled.div`
//   position: relative;
//   min-height: 100vh;
//   overflow: hidden;
//   color: white;
//   display: flex;
//   flex-direction: column;
//   font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
// `;

// const BackgroundVideo = styled.video`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   z-index: -2;
// `;

// const Overlay = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background: rgba(15, 23, 42, 0.5);
//   z-index: -1;
// `;

// const Header = styled.header`
//   background: rgba(15, 23, 42, 0.85);
//   backdrop-filter: blur(12px);
//   padding: 12px 20px;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   position: fixed;
//   width: 100%;
//   z-index: 1000;
//   border-bottom: 1px solid rgba(255,255,255,0.1);
//   flex-wrap: wrap;
  
//   @media (max-width: 768px) {
//     padding: 10px 12px;
//     flex-wrap: nowrap;
//     gap: 6px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 8px 10px;
//     gap: 4px;
//   }
// `;

// const LogoContainer = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   cursor: pointer;
//   flex-shrink: 0;
  
//   @media (max-width: 768px) {
//     gap: 6px;
//   }
  
//   @media (max-width: 480px) {
//     gap: 4px;
//   }
// `;

// const BrandLogo = styled.img`
//   width: 120px;
//   height: 50px;
//   object-fit: contain;
//   border-radius: 8px;
  
//   @media (max-width: 768px) {
//     width: 100px;
//     height: 40px;
//   }
  
//   @media (max-width: 480px) {
//     width: 100px;
//     height: 40px;
//   }
// `;

// const Nav = styled.nav`
//   display: flex;
//   gap: 40px;
//   align-items: center;
  
//   @media (max-width: 768px) {
//     display: none;
//   }
// `;

// const NavLink = styled.a`
//   color: white;
//   text-decoration: none;
//   font-weight: 600;
//   font-size: 0.95rem;
//   letter-spacing: 0.5px;
//   position: relative;
//   transition: color 0.3s ease;
//   cursor: pointer;
  
//   &:hover {
//     color: #a5b4fc;
//   }
  
//   &::after {
//     content: '';
//     position: absolute;
//     width: 0;
//     height: 2px;
//     bottom: -4px;
//     left: 0;
//     background: #6366f1;
//     transition: width 0.3s ease;
//   }
  
//   &:hover::after {
//     width: 100%;
//   }
// `;

// const MobileMenuButton = styled.button`
//   display: none;
//   background: none;
//   border: none;
//   color: white;
//   cursor: pointer;
//   padding: 4px;
//   margin-left: 2px;
//   flex-shrink: 0;
  
//   @media (max-width: 768px) {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }
// `;

// const MobileNav = styled.div`
//   display: ${props => props.isOpen ? 'flex' : 'none'};
//   position: fixed;
//   top: ${props => props.headerHeight || '70px'};
//   left: 0;
//   right: 0;
//   background: rgba(15, 23, 42, 0.98);
//   backdrop-filter: blur(12px);
//   flex-direction: column;
//   padding: 24px 20px;
//   gap: 16px;
//   z-index: 999;
//   border-bottom: 1px solid rgba(255,255,255,0.1);
//   max-height: calc(100vh - ${props => props.headerHeight || '70px'});
//   overflow-y: auto;
  
//   @media (max-width: 768px) {
//     padding: 20px 16px;
//     gap: 14px;
//   }
// `;

// const MobileNavLink = styled(NavLink)`
//   padding: 12px 16px;
//   border-radius: 8px;
//   font-size: 1.1rem;
//   width: 100%;
//   text-align: center;
//   border-bottom: 1px solid rgba(255,255,255,0.05);
  
//   &:hover {
//     background: rgba(255,255,255,0.05);
//   }
  
//   &::after {
//     display: none;
//   }
// `;

// const HeaderRight = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   flex-shrink: 1;
//   min-width: 0;
  
//   @media (max-width: 768px) {
//     gap: 4px;
//     flex: 1;
//     justify-content: flex-end;
//   }
  
//   @media (max-width: 480px) {
//     gap: 3px;
//   }
// `;

// const SocialButton = styled.a`
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   padding: 8px 14px;
//   border-radius: 9999px;
//   font-weight: 700;
//   font-size: 0.85rem;
//   text-decoration: none;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   cursor: pointer;
//   white-space: nowrap;
//   flex-shrink: 1;
//   min-width: 0;
  
//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.2);
//   }
  
//   @media (max-width: 768px) {
//     padding: 5px 10px;
//     font-size: 0.7rem;
//     gap: 4px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 4px 8px;
//     font-size: 0.6rem;
//     gap: 3px;
//   }
// `;

// const KingsChatButton = styled(SocialButton)`
//   background: #fff;
//   color: #2360ff;
  
//   &:hover {
//     background: #1e55e0;
//     color: white;
//   }
// `;

// const ContactButton = styled(SocialButton)`
//   background: #25D366;
//   color: white;
  
//   &:hover {
//     background: #22c55e;
//   }
// `;

// const SocialIcon = styled.img`
//   width: 18px;
//   height: 18px;
//   flex-shrink: 0;
  
//   @media (max-width: 768px) {
//     width: 14px;
//     height: 14px;
//   }
  
//   @media (max-width: 480px) {
//     width: 12px;
//     height: 12px;
//   }
// `;

// const SocialText = styled.span`
//   display: inline;
  
//   @media (max-width: 480px) {
//     font-size: 0.55rem;
//   }
// `;

// const MainContent = styled.main`
//   flex: 1;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding-top: 80px;
//   position: relative;
//   z-index: 10;
//   padding-bottom: 60px;
  
//   @media (max-width: 768px) {
//     padding-top: 70px;
//   }
// `;

// const HeroSection = styled.div`
//   text-align: center;
//   max-width: 960px;
//   padding: 0 24px;
//   background: rgba(15, 23, 42, 0.3);
//   backdrop-filter: blur(8px);
//   border: 1px solid rgba(255,255,255,0.15);
//   border-radius: 28px;
//   padding: 64px 48px;
//   box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.5);
  
//   @media (max-width: 768px) {
//     padding: 32px 20px;
//     margin: 16px;
//     border-radius: 20px;
//     background: rgba(15, 23, 42, 0.25);
//   }
  
//   @media (max-width: 480px) {
//     padding: 24px 16px;
//     margin: 12px;
//     background: rgba(15, 23, 42, 0.2);
//   }
// `;

// const HeraldLogo = styled.h1`
//   font-size: 4.5rem;
//   font-weight: 900;
//   letter-spacing: -3px;
//   margin-bottom: 16px;
//   background: linear-gradient(90deg, #f1f5f9, #e0f2fe, #c7d2fe);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   line-height: 1;
//   text-shadow: 0 4px 20px rgba(0,0,0,0.3);
  
//   @media (max-width: 768px) {
//     font-size: 3rem;
//   }
  
//   @media (max-width: 480px) {
//     font-size: 2.5rem;
//   }
// `;

// const SubtitleText = styled.p`
//   font-size: 1.45rem;
//   margin-bottom: 12px;
//   font-weight: 600;
//   color: #e0f2fe;
//   line-height: 1.4;
//   text-shadow: 0 2px 10px rgba(0,0,0,0.3);
  
//   @media (max-width: 768px) {
//     font-size: 1.1rem;
//   }
  
//   @media (max-width: 480px) {
//     font-size: 0.95rem;
//   }
// `;

// const Tagline = styled.p`
//   font-size: 1.2rem;
//   color: #bae6fd;
//   max-width: 620px;
//   margin: 0 auto 48px;
//   line-height: 1.5;
//   text-shadow: 0 2px 10px rgba(0,0,0,0.3);
  
//   @media (max-width: 768px) {
//     font-size: 1rem;
//     margin-bottom: 32px;
//   }
  
//   @media (max-width: 480px) {
//     font-size: 0.9rem;
//     margin-bottom: 24px;
//   }
// `;

// const ButtonsContainer = styled.div`
//   display: flex;
//   gap: 20px;
//   justify-content: center;
//   flex-wrap: wrap;
  
//   @media (max-width: 768px) {
//     flex-direction: column;
//     align-items: center;
//     gap: 12px;
//   }
// `;

// const PrimaryButton = styled.button`
//   padding: 16px 40px;
//   background: linear-gradient(90deg, #6366f1, #4f46e5);
//   color: white;
//   border: none;
//   border-radius: 9999px;
//   font-size: 1.05rem;
//   font-weight: 700;
//   cursor: pointer;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   box-shadow: 0 10px 15px -3px rgba(99, 102, 241, 0.5);
  
//   &:hover {
//     transform: translateY(-4px) scale(1.02);
//     box-shadow: 0 20px 25px -5px rgba(99, 102, 241, 0.6);
//   }
  
//   @media (max-width: 768px) {
//     padding: 14px 32px;
//     font-size: 0.95rem;
//     width: 100%;
//     max-width: 320px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 12px 24px;
//     font-size: 0.9rem;
//     max-width: 280px;
//   }
// `;

// const SecondaryButton = styled.button`
//   padding: 16px 40px;
//   background: rgba(255,255,255,0.15);
//   color: white;
//   border: 2px solid rgba(255,255,255,0.6);
//   border-radius: 9999px;
//   font-size: 1.05rem;
//   font-weight: 700;
//   cursor: pointer;
//   backdrop-filter: blur(8px);
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
//   &:hover {
//     background: rgba(255,255,255,0.25);
//     border-color: rgba(255,255,255,0.9);
//     transform: translateY(-2px);
//   }
  
//   @media (max-width: 768px) {
//     padding: 14px 32px;
//     font-size: 0.95rem;
//     width: 100%;
//     max-width: 320px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 12px 24px;
//     font-size: 0.9rem;
//     max-width: 280px;
//   }
// `;

// /* Mute Button Styles */
// const MuteButton = styled.button`
//   position: fixed;
//   bottom: 30px;
//   right: 30px;
//   z-index: 100;
//   width: 56px;
//   height: 56px;
//   border-radius: 50%;
//   border: 2px solid rgba(255, 255, 255, 0.3);
//   background: rgba(15, 23, 42, 0.7);
//   backdrop-filter: blur(12px);
//   color: white;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
//   font-size: 24px;
  
//   &:hover {
//     transform: scale(1.1);
//     background: rgba(15, 23, 42, 0.9);
//     border-color: rgba(255, 255, 255, 0.6);
//     box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
//   }
  
//   &:active {
//     transform: scale(0.95);
//   }
  
//   @media (max-width: 768px) {
//     width: 48px;
//     height: 48px;
//     bottom: 20px;
//     right: 20px;
//     font-size: 20px;
//   }
  
//   @media (max-width: 480px) {
//     width: 42px;
//     height: 42px;
//     bottom: 16px;
//     right: 16px;
//     font-size: 18px;
//   }
// `;

// const MuteTooltip = styled.span`
//   position: absolute;
//   bottom: calc(100% + 12px);
//   right: 50%;
//   transform: translateX(50%);
//   background: rgba(15, 23, 42, 0.9);
//   backdrop-filter: blur(8px);
//   color: white;
//   padding: 6px 14px;
//   border-radius: 8px;
//   font-size: 12px;
//   font-weight: 600;
//   white-space: nowrap;
//   border: 1px solid rgba(255, 255, 255, 0.1);
//   opacity: 0;
//   pointer-events: none;
//   transition: all 0.3s ease;
  
//   ${MuteButton}:hover & {
//     opacity: 1;
//     transform: translateX(50%) translateY(-4px);
//   }
// `;

// /* Modal Styles */
// const ModalOverlay = styled.div`
//   position: fixed;
//   inset: 0;
//   background: rgba(0,0,0,0.8);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index: 2000;
//   padding: 20px;
// `;

// const ModalCard = styled.div`
//   background: white;
//   width: 100%;
//   max-width: 460px;
//   border-radius: 24px;
//   padding: 40px;
//   color: #0f172a;
//   box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  
//   @media (max-width: 640px) {
//     padding: 28px 20px;
//     margin: 16px;
//   }
// `;

// /* Form Styles */
// const Form = styled.form``;

// const FormGroup = styled.div`
//   margin-bottom: 20px;
//   text-align: left;
// `;

// const Label = styled.label`
//   display: block;
//   color: #1e293b;
//   margin-bottom: 8px;
//   font-size: 14px;
//   font-weight: 700;
// `;

// const Input = styled.input`
//   width: 100%;
//   padding: 15px 18px;
//   border: 2px solid #e2e8f0;
//   border-radius: 14px;
//   font-size: 16px;
//   transition: all 0.2s ease;
//   box-sizing: border-box;
  
//   &:focus {
//     outline: none;
//     border-color: #6366f1;
//     box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.15);
//   }
// `;

// const SubmitButton = styled.button`
//   width: 100%;
//   padding: 16px;
//   background: linear-gradient(90deg, #1e40af, #1e3a8a);
//   border: none;
//   border-radius: 9999px;
//   color: white;
//   font-size: 1.1rem;
//   font-weight: 700;
//   cursor: pointer;
//   margin-top: 12px;
//   transition: all 0.3s;
  
//   &:hover {
//     transform: translateY(-2px);
//   }
// `;

// const CancelButton = styled.button`
//   width: 100%;
//   padding: 16px;
//   background: transparent;
//   border: 2px solid #64748b;
//   border-radius: 9999px;
//   color: #64748b;
//   font-size: 1.1rem;
//   font-weight: 700;
//   cursor: pointer;
//   margin-top: 12px;
  
//   &:hover {
//     background: #f8fafc;
//   }
// `;

// /* ================= MAIN COMPONENT ================= */
// const Login = ({ setUser }) => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [selectedRole, setSelectedRole] = useState('staff');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
  
//   const [showLeadForm, setShowLeadForm] = useState(false);
//   const [targetRoute, setTargetRoute] = useState("");
//   const [leadData, setLeadData] = useState({
//     fullName: "",
//     email: "",
//     phone: "",
//   });
//   const [emailOnly, setEmailOnly] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [headerHeight, setHeaderHeight] = useState('70px');
  
//   // Video mute state
//   const [isMuted, setIsMuted] = useState(true);
//   const videoRef = useRef(null);

//   const navigate = useNavigate();

//   // Get header height for mobile menu positioning
//   React.useEffect(() => {
//     const updateHeaderHeight = () => {
//       const header = document.querySelector('header');
//       if (header) {
//         setHeaderHeight(`${header.offsetHeight}px`);
//       }
//     };
    
//     updateHeaderHeight();
//     window.addEventListener('resize', updateHeaderHeight);
    
//     return () => {
//       window.removeEventListener('resize', updateHeaderHeight);
//     };
//   }, []);

//   // Toggle video mute
//   const toggleMute = () => {
//     if (videoRef.current) {
//       videoRef.current.muted = !videoRef.current.muted;
//       setIsMuted(videoRef.current.muted);
//     }
//   };

//   const handleProtectedNavigation = (route) => {
//     setTargetRoute(route);
//     setShowLeadForm(true);
//     setIsMobileMenuOpen(false);
//   };

//   const submitLead = async (e) => {
//     e.preventDefault();
//     try {
//       const userData = {
//         name: leadData.fullName || "Guest",
//         email: leadData.email,
//         role: selectedRole
//       };
      
//       setUser(userData);
//       localStorage.setItem("token", "your-auth-token-here");
      
//       setShowLeadForm(false);
//       navigate(targetRoute || "/dashboard");
//     } catch (error) {
//       console.error("Lead submission error:", error);
//       navigate(targetRoute || "/dashboard");
//     }
//   };

//   const cancelLeadForm = () => {
//     setShowLeadForm(false);
//     setLeadData({ fullName: "", email: "", phone: "" });
//     setEmailOnly(false);
//   };

//   return (
//     <LoginContainer>
//       {/* Background Video */}
//       <BackgroundVideo 
//         ref={videoRef}
//         autoPlay 
//         loop 
//         muted 
//         playsInline
//       >
//         <source
//           src="https://cdn1.kingschat.online/uploads/media/57fbe8f538da4d5569ad1cff/ODVSNjB0SS9PQlhUakxuQm5Zc0ZpUT09/808133.mp4"
//           type="video/mp4"
//         />
//       </BackgroundVideo>
      
//       <Overlay />

//       {/* Header */}
//       <Header>
//         <LogoContainer onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
//           <BrandLogo src={logo} alt="SPIRITMAN" />
//         </LogoContainer>

//         <Nav>
//           <NavLink onClick={() => handleProtectedNavigation("/dashboard")}>HOME</NavLink>
//           <NavLink onClick={() => navigate("/about")}>About Us</NavLink>
//           <NavLink onClick={() => handleProtectedNavigation("/resources")}>Resources</NavLink>
//         </Nav>

//         <HeaderRight>
//           <KingsChatButton
//             href="https://kingschat.online/user/spiritman.online"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <SocialIcon 
//               src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/VnBZbVVyUXBXNGE3R1lmVmVlZWJQQT09/kingsch.jpg" 
//               alt="KingsChat" 
//             />
//             <SocialText>KingsChat</SocialText>
//           </KingsChatButton>

//           <ContactButton
//             href="https://wa.link/ss0tjf"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <MessageCircle size={16} />
//             <SocialText>WhatsApp</SocialText>
//           </ContactButton>

//           <MobileMenuButton onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
//             {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
//           </MobileMenuButton>
//         </HeaderRight>
//       </Header>

//       {/* Mobile Navigation */}
//       <MobileNav isOpen={isMobileMenuOpen} headerHeight={headerHeight}>
//         <MobileNavLink onClick={() => handleProtectedNavigation("/dashboard")}>HOME</MobileNavLink>
//         <MobileNavLink onClick={() => navigate("/about")}>About Us</MobileNavLink>
//         <MobileNavLink onClick={() => handleProtectedNavigation("/resources")}>Resources</MobileNavLink>
//       </MobileNav>

//       <MainContent>
//         <HeroSection>
//           <HeraldLogo>SPIRITMAN</HeraldLogo>
//           <SubtitleText>Global Missions • AI for Church Growth • AI for Kingdom Business</SubtitleText>
//           <Tagline>
//             Empowering the Church with technology. Reaching the last lost soul through digital evangelism.
//           </Tagline>
          
//           <ButtonsContainer>
//             <PrimaryButton
//               onClick={() => handleProtectedNavigation("/evangelist")}
//             >
//               Become a DIGITAL EVANGELIST
//             </PrimaryButton>
            
//             <SecondaryButton
//               onClick={() => handleProtectedNavigation("/resources")}
//             >
//               Access Resources
//             </SecondaryButton>
//           </ButtonsContainer>
//         </HeroSection>
//       </MainContent>

//       {/* Mute/Unmute Button */}
//       <MuteButton onClick={toggleMute}>
//         {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
//         <MuteTooltip>
//           {isMuted ? 'Unmute' : 'Mute'}
//         </MuteTooltip>
//       </MuteButton>

//       {/* Lead Capture Modal */}
//       {showLeadForm && (
//         <ModalOverlay>
//           <ModalCard>
//             <h2 style={{ marginBottom: '8px', fontSize: '1.75rem' }}>Stay Connected</h2>
//             <p style={{ color: '#64748b', marginBottom: '32px' }}>
//               Kindly provide your details before proceeding.
//             </p>
            
//             <Form onSubmit={submitLead}>
//               {!emailOnly && (
//                 <>
//                   <FormGroup>
//                     <Label>Full Name</Label>
//                     <Input
//                       value={leadData.fullName}
//                       onChange={(e) => setLeadData({ ...leadData, fullName: e.target.value })}
//                       placeholder="John Doe"
//                     />
//                   </FormGroup>
                  
//                   <FormGroup>
//                     <Label>Phone Number</Label>
//                     <Input
//                       value={leadData.phone}
//                       onChange={(e) => setLeadData({ ...leadData, phone: e.target.value })}
//                       placeholder="+234 801 234 5678"
//                     />
//                   </FormGroup>
//                 </>
//               )}
              
//               <FormGroup>
//                 <Label>Email Address</Label>
//                 <Input
//                   type="email"
//                   required
//                   value={leadData.email}
//                   onChange={(e) => setLeadData({ ...leadData, email: e.target.value })}
//                   placeholder="you@example.com"
//                 />
//               </FormGroup>

//               <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '28px', cursor: 'pointer' }}>
//                 <input
//                   type="checkbox"
//                   checked={emailOnly}
//                   onChange={() => setEmailOnly(!emailOnly)}
//                 />
//                 <span style={{ fontSize: '0.95rem', color: '#475569' }}>Email only</span>
//               </label>

//               <SubmitButton type="submit">Continue</SubmitButton>
//               <CancelButton type="button" onClick={cancelLeadForm}>
//                 Cancel
//               </CancelButton>
//             </Form>
//           </ModalCard>
//         </ModalOverlay>
//       )}
//     </LoginContainer>
//   );
// };

// export default Login;



// import React, { useState, useRef, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
// import { FaEye, FaEyeSlash, FaVolumeMute, FaVolumeUp, FaUserPlus, FaUserCheck } from "react-icons/fa";
// import { MessageCircle, ExternalLink, Menu, X, Mail, User, Phone } from "lucide-react";
// import api from '../api';
// import LogoImg from "./assets/performance_logo.png";
// import logo from "../assets/SpitMan.jpeg"; // SPIRITMAN logo

// /* ================= STYLED COMPONENTS ================= */
// const LoginContainer = styled.div`
//   position: relative;
//   min-height: 100vh;
//   overflow: hidden;
//   color: white;
//   display: flex;
//   flex-direction: column;
//   font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
// `;

// const BackgroundVideo = styled.video`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   z-index: -2;
// `;

// const Overlay = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background: rgba(15, 23, 42, 0.5);
//   z-index: -1;
// `;

// const Header = styled.header`
//   background: rgba(15, 23, 42, 0.85);
//   backdrop-filter: blur(12px);
//   padding: 12px 20px;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   position: fixed;
//   width: 100%;
//   z-index: 1000;
//   border-bottom: 1px solid rgba(255,255,255,0.1);
//   flex-wrap: wrap;
  
//   @media (max-width: 768px) {
//     padding: 10px 12px;
//     flex-wrap: nowrap;
//     gap: 6px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 8px 10px;
//     gap: 4px;
//   }
// `;

// const LogoContainer = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   cursor: pointer;
//   flex-shrink: 0;
  
//   @media (max-width: 768px) {
//     gap: 6px;
//   }
  
//   @media (max-width: 480px) {
//     gap: 4px;
//   }
// `;

// const BrandLogo = styled.img`
//   width: 120px;
//   height: 50px;
//   object-fit: contain;
//   border-radius: 8px;
  
//   @media (max-width: 768px) {
//     width: 100px;
//     height: 40px;
//   }
  
//   @media (max-width: 480px) {
//     width: 100px;
//     height: 40px;
//   }
// `;

// const Nav = styled.nav`
//   display: flex;
//   gap: 40px;
//   align-items: center;
  
//   @media (max-width: 768px) {
//     display: none;
//   }
// `;

// const NavLink = styled.a`
//   color: white;
//   text-decoration: none;
//   font-weight: 600;
//   font-size: 0.95rem;
//   letter-spacing: 0.5px;
//   position: relative;
//   transition: color 0.3s ease;
//   cursor: pointer;
  
//   &:hover {
//     color: #a5b4fc;
//   }
  
//   &::after {
//     content: '';
//     position: absolute;
//     width: 0;
//     height: 2px;
//     bottom: -4px;
//     left: 0;
//     background: #6366f1;
//     transition: width 0.3s ease;
//   }
  
//   &:hover::after {
//     width: 100%;
//   }
// `;

// const MobileMenuButton = styled.button`
//   display: none;
//   background: none;
//   border: none;
//   color: white;
//   cursor: pointer;
//   padding: 4px;
//   margin-left: 2px;
//   flex-shrink: 0;
  
//   @media (max-width: 768px) {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }
// `;

// const MobileNav = styled.div`
//   display: ${props => props.isOpen ? 'flex' : 'none'};
//   position: fixed;
//   top: ${props => props.headerHeight || '70px'};
//   left: 0;
//   right: 0;
//   background: rgba(15, 23, 42, 0.98);
//   backdrop-filter: blur(12px);
//   flex-direction: column;
//   padding: 24px 20px;
//   gap: 16px;
//   z-index: 999;
//   border-bottom: 1px solid rgba(255,255,255,0.1);
//   max-height: calc(100vh - ${props => props.headerHeight || '70px'});
//   overflow-y: auto;
  
//   @media (max-width: 768px) {
//     padding: 20px 16px;
//     gap: 14px;
//   }
// `;

// const MobileNavLink = styled(NavLink)`
//   padding: 12px 16px;
//   border-radius: 8px;
//   font-size: 1.1rem;
//   width: 100%;
//   text-align: center;
//   border-bottom: 1px solid rgba(255,255,255,0.05);
  
//   &:hover {
//     background: rgba(255,255,255,0.05);
//   }
  
//   &::after {
//     display: none;
//   }
// `;

// const HeaderRight = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   flex-shrink: 1;
//   min-width: 0;
  
//   @media (max-width: 768px) {
//     gap: 4px;
//     flex: 1;
//     justify-content: flex-end;
//   }
  
//   @media (max-width: 480px) {
//     gap: 3px;
//   }
// `;

// const SocialButton = styled.a`
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   padding: 8px 14px;
//   border-radius: 9999px;
//   font-weight: 700;
//   font-size: 0.85rem;
//   text-decoration: none;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   cursor: pointer;
//   white-space: nowrap;
//   flex-shrink: 1;
//   min-width: 0;
  
//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.2);
//   }
  
//   @media (max-width: 768px) {
//     padding: 5px 10px;
//     font-size: 0.7rem;
//     gap: 4px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 4px 8px;
//     font-size: 0.6rem;
//     gap: 3px;
//   }
// `;

// const KingsChatButton = styled(SocialButton)`
//   background: #fff;
//   color: #2360ff;
  
//   &:hover {
//     background: #1e55e0;
//     color: white;
//   }
// `;

// const ContactButton = styled(SocialButton)`
//   background: #25D366;
//   color: white;
  
//   &:hover {
//     background: #22c55e;
//   }
// `;

// const SocialIcon = styled.img`
//   width: 18px;
//   height: 18px;
//   flex-shrink: 0;
  
//   @media (max-width: 768px) {
//     width: 14px;
//     height: 14px;
//   }
  
//   @media (max-width: 480px) {
//     width: 12px;
//     height: 12px;
//   }
// `;

// const SocialText = styled.span`
//   display: inline;
  
//   @media (max-width: 480px) {
//     font-size: 0.55rem;
//   }
// `;

// const MainContent = styled.main`
//   flex: 1;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding-top: 80px;
//   position: relative;
//   z-index: 10;
//   padding-bottom: 60px;
  
//   @media (max-width: 768px) {
//     padding-top: 70px;
//   }
// `;

// const HeroSection = styled.div`
//   text-align: center;
//   max-width: 960px;
//   padding: 0 24px;
//   background: rgba(15, 23, 42, 0.3);
//   backdrop-filter: blur(8px);
//   border: 1px solid rgba(255,255,255,0.15);
//   border-radius: 28px;
//   padding: 64px 48px;
//   box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.5);
  
//   @media (max-width: 768px) {
//     padding: 32px 20px;
//     margin: 16px;
//     border-radius: 20px;
//     background: rgba(15, 23, 42, 0.25);
//   }
  
//   @media (max-width: 480px) {
//     padding: 24px 16px;
//     margin: 12px;
//     background: rgba(15, 23, 42, 0.2);
//   }
// `;

// const HeraldLogo = styled.h1`
//   font-size: 4.5rem;
//   font-weight: 900;
//   letter-spacing: -3px;
//   margin-bottom: 16px;
//   background: linear-gradient(90deg, #f1f5f9, #e0f2fe, #c7d2fe);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   line-height: 1;
//   text-shadow: 0 4px 20px rgba(0,0,0,0.3);
  
//   @media (max-width: 768px) {
//     font-size: 3rem;
//   }
  
//   @media (max-width: 480px) {
//     font-size: 2.5rem;
//   }
// `;

// const SubtitleText = styled.p`
//   font-size: 1.45rem;
//   margin-bottom: 12px;
//   font-weight: 600;
//   color: #e0f2fe;
//   line-height: 1.4;
//   text-shadow: 0 2px 10px rgba(0,0,0,0.3);
  
//   @media (max-width: 768px) {
//     font-size: 1.1rem;
//   }
  
//   @media (max-width: 480px) {
//     font-size: 0.95rem;
//   }
// `;

// const Tagline = styled.p`
//   font-size: 1.2rem;
//   color: #bae6fd;
//   max-width: 620px;
//   margin: 0 auto 48px;
//   line-height: 1.5;
//   text-shadow: 0 2px 10px rgba(0,0,0,0.3);
  
//   @media (max-width: 768px) {
//     font-size: 1rem;
//     margin-bottom: 32px;
//   }
  
//   @media (max-width: 480px) {
//     font-size: 0.9rem;
//     margin-bottom: 24px;
//   }
// `;

// const ButtonsContainer = styled.div`
//   display: flex;
//   gap: 20px;
//   justify-content: center;
//   flex-wrap: wrap;
  
//   @media (max-width: 768px) {
//     flex-direction: column;
//     align-items: center;
//     gap: 12px;
//   }
// `;

// const PrimaryButton = styled.button`
//   padding: 16px 40px;
//   background: linear-gradient(90deg, #6366f1, #4f46e5);
//   color: white;
//   border: none;
//   border-radius: 9999px;
//   font-size: 1.05rem;
//   font-weight: 700;
//   cursor: pointer;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   box-shadow: 0 10px 15px -3px rgba(99, 102, 241, 0.5);
  
//   &:hover {
//     transform: translateY(-4px) scale(1.02);
//     box-shadow: 0 20px 25px -5px rgba(99, 102, 241, 0.6);
//   }
  
//   @media (max-width: 768px) {
//     padding: 14px 32px;
//     font-size: 0.95rem;
//     width: 100%;
//     max-width: 320px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 12px 24px;
//     font-size: 0.9rem;
//     max-width: 280px;
//   }
// `;

// const SecondaryButton = styled.button`
//   padding: 16px 40px;
//   background: rgba(255,255,255,0.15);
//   color: white;
//   border: 2px solid rgba(255,255,255,0.6);
//   border-radius: 9999px;
//   font-size: 1.05rem;
//   font-weight: 700;
//   cursor: pointer;
//   backdrop-filter: blur(8px);
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
//   &:hover {
//     background: rgba(255,255,255,0.25);
//     border-color: rgba(255,255,255,0.9);
//     transform: translateY(-2px);
//   }
  
//   @media (max-width: 768px) {
//     padding: 14px 32px;
//     font-size: 0.95rem;
//     width: 100%;
//     max-width: 320px;
//   }
  
//   @media (max-width: 480px) {
//     padding: 12px 24px;
//     font-size: 0.9rem;
//     max-width: 280px;
//   }
// `;

// /* Mute Button Styles */
// const MuteButton = styled.button`
//   position: fixed;
//   bottom: 30px;
//   right: 30px;
//   z-index: 100;
//   width: 56px;
//   height: 56px;
//   border-radius: 50%;
//   border: 2px solid rgba(255, 255, 255, 0.3);
//   background: rgba(15, 23, 42, 0.7);
//   backdrop-filter: blur(12px);
//   color: white;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
//   font-size: 24px;
  
//   &:hover {
//     transform: scale(1.1);
//     background: rgba(15, 23, 42, 0.9);
//     border-color: rgba(255, 255, 255, 0.6);
//     box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
//   }
  
//   &:active {
//     transform: scale(0.95);
//   }
  
//   @media (max-width: 768px) {
//     width: 48px;
//     height: 48px;
//     bottom: 20px;
//     right: 20px;
//     font-size: 20px;
//   }
  
//   @media (max-width: 480px) {
//     width: 42px;
//     height: 42px;
//     bottom: 16px;
//     right: 16px;
//     font-size: 18px;
//   }
// `;

// const MuteTooltip = styled.span`
//   position: absolute;
//   bottom: calc(100% + 12px);
//   right: 50%;
//   transform: translateX(50%);
//   background: rgba(15, 23, 42, 0.9);
//   backdrop-filter: blur(8px);
//   color: white;
//   padding: 6px 14px;
//   border-radius: 8px;
//   font-size: 12px;
//   font-weight: 600;
//   white-space: nowrap;
//   border: 1px solid rgba(255, 255, 255, 0.1);
//   opacity: 0;
//   pointer-events: none;
//   transition: all 0.3s ease;
  
//   ${MuteButton}:hover & {
//     opacity: 1;
//     transform: translateX(50%) translateY(-4px);
//   }
// `;

// /* Modal Styles */
// const ModalOverlay = styled.div`
//   position: fixed;
//   inset: 0;
//   background: rgba(0,0,0,0.8);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index: 2000;
//   padding: 20px;
// `;

// const ModalCard = styled.div`
//   background: white;
//   width: 100%;
//   max-width: 480px;
//   border-radius: 24px;
//   padding: 40px;
//   color: #0f172a;
//   box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  
//   @media (max-width: 640px) {
//     padding: 28px 20px;
//     margin: 16px;
//   }
// `;

// /* Form Styles */
// const Form = styled.form``;

// const FormGroup = styled.div`
//   margin-bottom: 20px;
//   text-align: left;
// `;

// const Label = styled.label`
//   display: block;
//   color: #1e293b;
//   margin-bottom: 8px;
//   font-size: 14px;
//   font-weight: 700;
// `;

// const Input = styled.input`
//   width: 100%;
//   padding: 15px 18px;
//   border: 2px solid #e2e8f0;
//   border-radius: 14px;
//   font-size: 16px;
//   transition: all 0.2s ease;
//   box-sizing: border-box;
  
//   &:focus {
//     outline: none;
//     border-color: #6366f1;
//     box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.15);
//   }
// `;

// const InputWithIcon = styled.div`
//   position: relative;
//   width: 100%;
  
//   svg {
//     position: absolute;
//     left: 14px;
//     top: 50%;
//     transform: translateY(-50%);
//     color: #94a3b8;
//     width: 20px;
//     height: 20px;
//   }
  
//   input {
//     padding-left: 44px;
//   }
// `;

// const SubmitButton = styled.button`
//   width: 100%;
//   padding: 16px;
//   background: linear-gradient(90deg, #1e40af, #1e3a8a);
//   border: none;
//   border-radius: 9999px;
//   color: white;
//   font-size: 1.1rem;
//   font-weight: 700;
//   cursor: pointer;
//   margin-top: 12px;
//   transition: all 0.3s;
  
//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 10px 20px rgba(30, 64, 175, 0.3);
//   }
  
//   &:disabled {
//     opacity: 0.6;
//     cursor: not-allowed;
//     transform: none;
//   }
// `;

// const CancelButton = styled.button`
//   width: 100%;
//   padding: 16px;
//   background: transparent;
//   border: 2px solid #64748b;
//   border-radius: 9999px;
//   color: #64748b;
//   font-size: 1.1rem;
//   font-weight: 700;
//   cursor: pointer;
//   margin-top: 12px;
  
//   &:hover {
//     background: #f8fafc;
//   }
// `;

// const ErrorMessage = styled.div`
//   background: #fef2f2;
//   color: #dc2626;
//   padding: 12px 16px;
//   border-radius: 12px;
//   font-size: 14px;
//   margin-bottom: 20px;
//   border: 1px solid #fecaca;
//   display: flex;
//   align-items: center;
//   gap: 8px;
// `;

// const SuccessMessage = styled.div`
//   background: #f0fdf4;
//   color: #16a34a;
//   padding: 12px 16px;
//   border-radius: 12px;
//   font-size: 14px;
//   margin-bottom: 20px;
//   border: 1px solid #bbf7d0;
//   display: flex;
//   align-items: center;
//   gap: 8px;
// `;

// const ToggleMode = styled.button`
//   background: none;
//   border: none;
//   color: #6366f1;
//   font-weight: 600;
//   cursor: pointer;
//   font-size: 14px;
//   margin-top: 12px;
//   padding: 8px;
//   transition: color 0.3s;
//   width: 100%;
//   text-align: center;
  
//   &:hover {
//     color: #4f46e5;
//     text-decoration: underline;
//   }
// `;

// const ModeIndicator = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   background: ${props => props.isFirstTime ? '#eff6ff' : '#f0fdf4'};
//   padding: 8px 14px;
//   border-radius: 12px;
//   margin-bottom: 20px;
//   border: 1px solid ${props => props.isFirstTime ? '#bfdbfe' : '#bbf7d0'};
//   color: ${props => props.isFirstTime ? '#1e40af' : '#16a34a'};
//   font-weight: 600;
//   font-size: 14px;
  
//   svg {
//     font-size: 18px;
//   }
// `;

// /* ================= MAIN COMPONENT ================= */
// const Login = ({ setUser }) => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [selectedRole, setSelectedRole] = useState('staff');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
  
//   const [showLeadForm, setShowLeadForm] = useState(false);
//   const [targetRoute, setTargetRoute] = useState("");
//   const [leadData, setLeadData] = useState({
//     fullName: "",
//     email: "",
//     phone: "",
//   });
//   const [isFirstTime, setIsFirstTime] = useState(true); // Track if it's first time
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [headerHeight, setHeaderHeight] = useState('70px');
//   const [isCheckingEmail, setIsCheckingEmail] = useState(false);
  
//   // Video mute state
//   const [isMuted, setIsMuted] = useState(true);
//   const videoRef = useRef(null);

//   const navigate = useNavigate();

//   // Get header height for mobile menu positioning
//   React.useEffect(() => {
//     const updateHeaderHeight = () => {
//       const header = document.querySelector('header');
//       if (header) {
//         setHeaderHeight(`${header.offsetHeight}px`);
//       }
//     };
    
//     updateHeaderHeight();
//     window.addEventListener('resize', updateHeaderHeight);
    
//     return () => {
//       window.removeEventListener('resize', updateHeaderHeight);
//     };
//   }, []);

//   // Toggle video mute
//   const toggleMute = () => {
//     if (videoRef.current) {
//       videoRef.current.muted = !videoRef.current.muted;
//       setIsMuted(videoRef.current.muted);
//     }
//   };

//   const handleProtectedNavigation = (route) => {
//     setTargetRoute(route);
//     // Reset form for new entry
//     setLeadData({ fullName: "", email: "", phone: "" });
//     setError('');
//     setIsFirstTime(true);
//     setShowLeadForm(true);
//     setIsMobileMenuOpen(false);
//   };

//   // Check if email exists in system
//   const checkEmailExists = async (email) => {
//     if (!email || email.length < 3) return false;
    
//     setIsCheckingEmail(true);
//     try {
//       // You can implement an API call to check if email exists
//       // For now, we'll simulate with localStorage
//       const existingLeads = JSON.parse(localStorage.getItem('leads') || '[]');
//       const found = existingLeads.some(lead => lead.email === email);
      
//       // Also check in the current session
//       const currentLead = JSON.parse(sessionStorage.getItem('currentLead') || 'null');
//       if (currentLead && currentLead.email === email) {
//         setIsFirstTime(false);
//         setLeadData(prev => ({
//           ...prev,
//           fullName: currentLead.fullName || '',
//           phone: currentLead.phone || ''
//         }));
//         return true;
//       }
      
//       if (found) {
//         // Find the existing lead data
//         const existingLead = existingLeads.find(lead => lead.email === email);
//         if (existingLead) {
//           setLeadData(prev => ({
//             ...prev,
//             fullName: existingLead.fullName || '',
//             phone: existingLead.phone || ''
//           }));
//         }
//         setIsFirstTime(false);
//         return true;
//       }
      
//       setIsFirstTime(true);
//       return false;
//     } catch (error) {
//       console.error('Error checking email:', error);
//       return false;
//     } finally {
//       setIsCheckingEmail(false);
//     }
//   };

//   // Handle email change with debounce
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (leadData.email && leadData.email.includes('@')) {
//         checkEmailExists(leadData.email);
//       }
//     }, 500);
    
//     return () => clearTimeout(timer);
//   }, [leadData.email]);

//   const submitLead = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');
    
//     try {
//       // Validate based on mode
//       if (isFirstTime) {
//         // First time: all fields required
//         if (!leadData.fullName || !leadData.email || !leadData.phone) {
//           setError('Please fill in all fields (Full Name, Email, and Phone)');
//           setLoading(false);
//           return;
//         }
//       } else {
//         // Returning: only email required
//         if (!leadData.email) {
//           setError('Please enter your email address');
//           setLoading(false);
//           return;
//         }
//       }
      
//       // Prepare user data
//       const userData = {
//         name: leadData.fullName || "Guest",
//         email: leadData.email,
//         phone: leadData.phone || '',
//         role: selectedRole,
//         isFirstTime: isFirstTime
//       };
      
//       // Save to localStorage for demo
//       const existingLeads = JSON.parse(localStorage.getItem('leads') || '[]');
      
//       // Check if lead exists
//       const existingIndex = existingLeads.findIndex(lead => lead.email === leadData.email);
      
//       if (existingIndex >= 0) {
//         // Update existing lead
//         existingLeads[existingIndex] = {
//           ...existingLeads[existingIndex],
//           fullName: leadData.fullName || existingLeads[existingIndex].fullName,
//           phone: leadData.phone || existingLeads[existingIndex].phone,
//           lastVisit: new Date().toISOString()
//         };
//       } else {
//         // Add new lead
//         existingLeads.push({
//           email: leadData.email,
//           fullName: leadData.fullName || "Guest",
//           phone: leadData.phone || '',
//           role: selectedRole,
//           firstVisit: new Date().toISOString(),
//           lastVisit: new Date().toISOString()
//         });
//       }
      
//       localStorage.setItem('leads', JSON.stringify(existingLeads));
      
//       // Store current lead in session
//       sessionStorage.setItem('currentLead', JSON.stringify({
//         email: leadData.email,
//         fullName: leadData.fullName,
//         phone: leadData.phone
//       }));
      
//       setUser(userData);
//       localStorage.setItem("token", "your-auth-token-here");
      
//       setShowLeadForm(false);
//       navigate(targetRoute || "/dashboard");
      
//     } catch (error) {
//       console.error("Lead submission error:", error);
//       setError(error.response?.data?.message || "Failed to submit. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const cancelLeadForm = () => {
//     setShowLeadForm(false);
//     setLeadData({ fullName: "", email: "", phone: "" });
//     setError('');
//     setIsFirstTime(true);
//   };

//   // Toggle between first time and returning
//   const toggleMode = () => {
//     setIsFirstTime(!isFirstTime);
//     setError('');
//     if (!isFirstTime) {
//       // Switching to first time mode - clear pre-filled data
//       setLeadData(prev => ({ ...prev, fullName: "", phone: "" }));
//     }
//   };

//   return (
//     <LoginContainer>
//       {/* Background Video */}
//       <BackgroundVideo 
//         ref={videoRef}
//         autoPlay 
//         loop 
//         muted 
//         playsInline
//       >
//         <source
//           src="https://cdn1.kingschat.online/uploads/media/57fbe8f538da4d5569ad1cff/ODVSNjB0SS9PQlhUakxuQm5Zc0ZpUT09/808133.mp4"
//           type="video/mp4"
//         />
//       </BackgroundVideo>
      
//       <Overlay />

//       {/* Header */}
//       <Header>
//         <LogoContainer onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
//           <BrandLogo src={logo} alt="SPIRITMAN" />
//         </LogoContainer>

//         <Nav>
//           <NavLink onClick={() => handleProtectedNavigation("/dashboard")}>HOME</NavLink>
//           <NavLink onClick={() => navigate("/about")}>About Us</NavLink>
//           <NavLink onClick={() => handleProtectedNavigation("/resources")}>Resources</NavLink>
//         </Nav>

//         <HeaderRight>
//           <KingsChatButton
//             href="https://kingschat.online/user/spiritman.online"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <SocialIcon 
//               src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/VnBZbVVyUXBXNGE3R1lmVmVlZWJQQT09/kingsch.jpg" 
//               alt="KingsChat" 
//             />
//             <SocialText>KingsChat</SocialText>
//           </KingsChatButton>

//           <ContactButton
//             href="https://wa.link/ss0tjf"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <MessageCircle size={16} />
//             <SocialText>WhatsApp</SocialText>
//           </ContactButton>

//           <MobileMenuButton onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
//             {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
//           </MobileMenuButton>
//         </HeaderRight>
//       </Header>

//       {/* Mobile Navigation */}
//       <MobileNav isOpen={isMobileMenuOpen} headerHeight={headerHeight}>
//         <MobileNavLink onClick={() => handleProtectedNavigation("/dashboard")}>HOME</MobileNavLink>
//         <MobileNavLink onClick={() => navigate("/about")}>About Us</MobileNavLink>
//         <MobileNavLink onClick={() => handleProtectedNavigation("/resources")}>Resources</MobileNavLink>
//       </MobileNav>

//       <MainContent>
//         <HeroSection>
//           <HeraldLogo>SPIRITMAN</HeraldLogo>
//           <SubtitleText>Global Missions • AI for Church Growth • AI for Kingdom Business</SubtitleText>
//           <Tagline>
//             Empowering the Church with technology. Reaching the last lost soul through digital evangelism.
//           </Tagline>
          
//           <ButtonsContainer>
//             <PrimaryButton
//               onClick={() => handleProtectedNavigation("/evangelist")}
//             >
//               Become a DIGITAL EVANGELIST
//             </PrimaryButton>
            
//             <SecondaryButton
//               onClick={() => handleProtectedNavigation("/resources")}
//             >
//               Access Resources
//             </SecondaryButton>
//           </ButtonsContainer>
//         </HeroSection>
//       </MainContent>

//       {/* Mute/Unmute Button */}
//       <MuteButton onClick={toggleMute}>
//         {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
//         <MuteTooltip>
//           {isMuted ? 'Unmute' : 'Mute'}
//         </MuteTooltip>
//       </MuteButton>

//       {/* Lead Capture Modal */}
//       {showLeadForm && (
//         <ModalOverlay>
//           <ModalCard>
//             <h2 style={{ marginBottom: '4px', fontSize: '1.75rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
//               {isFirstTime ? '✨ New Here?' : '👋 Welcome Back!'}
//             </h2>
//             <p style={{ color: '#64748b', marginBottom: '24px', fontSize: '0.95rem' }}>
//               {isFirstTime 
//                 ? 'Please fill in your details to get started.' 
//                 : `We remember you! Just confirm your email to continue.`}
//             </p>
            
//             <ModeIndicator isFirstTime={isFirstTime}>
//               {isFirstTime ? (
//                 <>
//                   <FaUserPlus /> First time visitor
//                 </>
//               ) : (
//                 <>
//                   <FaUserCheck /> Returning visitor
//                 </>
//               )}
//             </ModeIndicator>
            
//             {error && (
//               <ErrorMessage>
//                 <span>⚠️</span> {error}
//               </ErrorMessage>
//             )}
            
//             <Form onSubmit={submitLead}>
//               <FormGroup>
//                 <Label>Email Address</Label>
//                 <InputWithIcon>
//                   <Mail size={20} />
//                   <Input
//                     type="email"
//                     required
//                     value={leadData.email}
//                     onChange={(e) => setLeadData({ ...leadData, email: e.target.value })}
//                     placeholder="you@example.com"
//                     style={{ paddingLeft: '44px' }}
//                   />
//                 </InputWithIcon>
//                 {isCheckingEmail && (
//                   <div style={{ fontSize: '12px', color: '#6366f1', marginTop: '4px' }}>
//                     Checking...
//                   </div>
//                 )}
//                 {!isCheckingEmail && leadData.email && !isFirstTime && (
//                   <div style={{ fontSize: '12px', color: '#16a34a', marginTop: '4px' }}>
//                     ✓ Returning visitor - we found your details!
//                   </div>
//                 )}
//               </FormGroup>
              
//               {isFirstTime && (
//                 <>
//                   <FormGroup>
//                     <Label>Full Name</Label>
//                     <InputWithIcon>
//                       <User size={20} />
//                       <Input
//                         value={leadData.fullName}
//                         onChange={(e) => setLeadData({ ...leadData, fullName: e.target.value })}
//                         placeholder="John Doe"
//                         style={{ paddingLeft: '44px' }}
//                         required
//                       />
//                     </InputWithIcon>
//                   </FormGroup>
                  
//                   <FormGroup>
//                     <Label>Phone Number</Label>
//                     <InputWithIcon>
//                       <Phone size={20} />
//                       <Input
//                         value={leadData.phone}
//                         onChange={(e) => setLeadData({ ...leadData, phone: e.target.value })}
//                         placeholder="+234 801 234 5678"
//                         style={{ paddingLeft: '44px' }}
//                         required
//                       />
//                     </InputWithIcon>
//                   </FormGroup>
//                 </>
//               )}

//               <SubmitButton type="submit" disabled={loading}>
//                 {loading ? 'Please wait...' : isFirstTime ? 'Get Started 🚀' : 'Continue →'}
//               </SubmitButton>
              
//               <ToggleMode type="button" onClick={toggleMode}>
//                 {isFirstTime ? 'Already have an account? Sign in with email' : 'New user? Register with full details'}
//               </ToggleMode>
              
//               <CancelButton type="button" onClick={cancelLeadForm}>
//                 Cancel
//               </CancelButton>
//             </Form>
//           </ModalCard>
//         </ModalOverlay>
//       )}
//     </LoginContainer>
//   );
// };

// export default Login;
//MobileNav

import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FaEye, FaEyeSlash, FaVolumeMute, FaVolumeUp, FaUserPlus, FaUserCheck } from "react-icons/fa";
import { MessageCircle, ExternalLink, Menu, X, Mail, User, Phone } from "lucide-react";
import api from '../api';
import LogoImg from "./assets/performance_logo.png";
import logo from "../assets/SpitMan.jpeg"; // SPIRITMAN logo

/* ================= STYLED COMPONENTS ================= */
const LoginContainer = styled.div`
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  color: white;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.5);
  z-index: -1;
`;

const Header = styled.header`
  background: rgba(15, 23, 42, 0.85);
  backdrop-filter: blur(12px);
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1000;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    padding: 10px 12px;
    flex-wrap: nowrap;
    gap: 6px;
  }
  
  @media (max-width: 480px) {
    padding: 8px 10px;
    gap: 4px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    gap: 6px;
  }
  
  @media (max-width: 480px) {
    gap: 4px;
  }
`;

const BrandLogo = styled.img`
  width: 120px;
  height: 50px;
  object-fit: contain;
  border-radius: 8px;
  
  @media (max-width: 768px) {
    width: 100px;
    height: 40px;
  }
  
  @media (max-width: 480px) {
    width: 100px;
    height: 40px;
  }
`;

const Nav = styled.nav`
  display: flex;
  gap: 40px;
  align-items: center;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.a`
  color: white;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  position: relative;
  transition: color 0.3s ease;
  cursor: pointer;
  
  &:hover {
    color: #a5b4fc;
  }
  
  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -4px;
    left: 0;
    background: #6366f1;
    transition: width 0.3s ease;
  }
  
  &:hover::after {
    width: 100%;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 4px;
  margin-left: 2px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const MobileNav = styled.div`
  display: ${props => props.isOpen ? 'flex' : 'none'};
  position: fixed;
  top: ${props => props.headerHeight || '70px'};
  left: 0;
  right: 0;
  background: rgba(15, 23, 42, 0.98);
  backdrop-filter: blur(12px);
  flex-direction: column;
  padding: 24px 20px;
  gap: 16px;
  z-index: 999;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  max-height: calc(100vh - ${props => props.headerHeight || '70px'});
  overflow-y: auto;
  
  @media (max-width: 768px) {
    padding: 20px 16px;
    gap: 14px;
  }
`;

const MobileNavLink = styled(NavLink)`
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 1.1rem;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  
  &:hover {
    background: rgba(255,255,255,0.05);
  }
  
  &::after {
    display: none;
  }
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 1;
  min-width: 0;
  
  @media (max-width: 768px) {
    gap: 4px;
    flex: 1;
    justify-content: flex-end;
  }
  
  @media (max-width: 480px) {
    gap: 3px;
  }
`;

const SocialButton = styled.a`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 9999px;
  font-weight: 700;
  font-size: 0.85rem;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 1;
  min-width: 0;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.2);
  }
  
  @media (max-width: 768px) {
    padding: 5px 10px;
    font-size: 0.7rem;
    gap: 4px;
  }
  
  @media (max-width: 480px) {
    padding: 4px 8px;
    font-size: 0.6rem;
    gap: 3px;
  }
`;

const KingsChatButton = styled(SocialButton)`
  background: #fff;
  color: #2360ff;
  
  &:hover {
    background: #1e55e0;
    color: white;
  }
`;

const ContactButton = styled(SocialButton)`
  background: #25D366;
  color: white;
  
  &:hover {
    background: #22c55e;
  }
`;

const SocialIcon = styled.img`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    width: 14px;
    height: 14px;
  }
  
  @media (max-width: 480px) {
    width: 12px;
    height: 12px;
  }
`;

const SocialText = styled.span`
  display: inline;
  
  @media (max-width: 480px) {
    font-size: 0.55rem;
  }
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 80px;
  position: relative;
  z-index: 10;
  padding-bottom: 60px;
  
  @media (max-width: 768px) {
    padding-top: 70px;
  }
`;

const HeroSection = styled.div`
  text-align: center;
  max-width: 960px;
  padding: 0 24px;
  background: rgba(15, 23, 42, 0.3);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 28px;
  padding: 64px 48px;
  box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.5);
  
  @media (max-width: 768px) {
    padding: 32px 20px;
    margin: 16px;
    border-radius: 20px;
    background: rgba(15, 23, 42, 0.25);
  }
  
  @media (max-width: 480px) {
    padding: 24px 16px;
    margin: 12px;
    background: rgba(15, 23, 42, 0.2);
  }
`;

const HeraldLogo = styled.h1`
  font-size: 4.5rem;
  font-weight: 900;
  letter-spacing: -3px;
  margin-bottom: 16px;
  background: linear-gradient(90deg, #f1f5f9, #e0f2fe, #c7d2fe);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1;
  text-shadow: 0 4px 20px rgba(0,0,0,0.3);
  
  @media (max-width: 768px) {
    font-size: 3rem;
  }
  
  @media (max-width: 480px) {
    font-size: 2.5rem;
  }
`;

const SubtitleText = styled.p`
  font-size: 1.45rem;
  margin-bottom: 12px;
  font-weight: 600;
  color: #e0f2fe;
  line-height: 1.4;
  text-shadow: 0 2px 10px rgba(0,0,0,0.3);
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
  
  @media (max-width: 480px) {
    font-size: 0.95rem;
  }
`;

const Tagline = styled.p`
  font-size: 1.2rem;
  color: #bae6fd;
  max-width: 620px;
  margin: 0 auto 48px;
  line-height: 1.5;
  text-shadow: 0 2px 10px rgba(0,0,0,0.3);
  
  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 32px;
  }
  
  @media (max-width: 480px) {
    font-size: 0.9rem;
    margin-bottom: 24px;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
`;

const PrimaryButton = styled.button`
  padding: 16px 40px;
  background: linear-gradient(90deg, #6366f1, #4f46e5);
  color: white;
  border: none;
  border-radius: 9999px;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 15px -3px rgba(99, 102, 241, 0.5);
  
  &:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow: 0 20px 25px -5px rgba(99, 102, 241, 0.6);
  }
  
  @media (max-width: 768px) {
    padding: 14px 32px;
    font-size: 0.95rem;
    width: 100%;
    max-width: 320px;
  }
  
  @media (max-width: 480px) {
    padding: 12px 24px;
    font-size: 0.9rem;
    max-width: 280px;
  }
`;

const SecondaryButton = styled.button`
  padding: 16px 40px;
  background: rgba(255,255,255,0.15);
  color: white;
  border: 2px solid rgba(255,255,255,0.6);
  border-radius: 9999px;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  backdrop-filter: blur(8px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    background: rgba(255,255,255,0.25);
    border-color: rgba(255,255,255,0.9);
    transform: translateY(-2px);
  }
  
  @media (max-width: 768px) {
    padding: 14px 32px;
    font-size: 0.95rem;
    width: 100%;
    max-width: 320px;
  }
  
  @media (max-width: 480px) {
    padding: 12px 24px;
    font-size: 0.9rem;
    max-width: 280px;
  }
`;

/* Mute Button Styles */
const MuteButton = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 100;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.3);
  background: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(12px);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  font-size: 24px;
  
  &:hover {
    transform: scale(1.1);
    background: rgba(15, 23, 42, 0.9);
    border-color: rgba(255, 255, 255, 0.6);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
    bottom: 20px;
    right: 20px;
    font-size: 20px;
  }
  
  @media (max-width: 480px) {
    width: 42px;
    height: 42px;
    bottom: 16px;
    right: 16px;
    font-size: 18px;
  }
`;

const MuteTooltip = styled.span`
  position: absolute;
  bottom: calc(100% + 12px);
  right: 50%;
  transform: translateX(50%);
  background: rgba(15, 23, 42, 0.9);
  backdrop-filter: blur(8px);
  color: white;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.1);
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease;
  
  ${MuteButton}:hover & {
    opacity: 1;
    transform: translateX(50%) translateY(-4px);
  }
`;

/* Modal Styles */
const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 20px;
`;

const ModalCard = styled.div`
  background: white;
  width: 100%;
  max-width: 480px;
  border-radius: 24px;
  padding: 40px;
  color: #0f172a;
  box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  
  @media (max-width: 640px) {
    padding: 28px 20px;
    margin: 16px;
  }
`;

/* Form Styles */
const Form = styled.form``;

const FormGroup = styled.div`
  margin-bottom: 20px;
  text-align: left;
`;

const Label = styled.label`
  display: block;
  color: #1e293b;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 700;
`;

const Input = styled.input`
  width: 100%;
  padding: 15px 18px;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  font-size: 16px;
  transition: all 0.2s ease;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.15);
  }
`;

const InputWithIcon = styled.div`
  position: relative;
  width: 100%;
  
  svg {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    width: 20px;
    height: 20px;
  }
  
  input {
    padding-left: 44px;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 16px;
  background: linear-gradient(90deg, #1e40af, #1e3a8a);
  border: none;
  border-radius: 9999px;
  color: white;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  margin-top: 12px;
  transition: all 0.3s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(30, 64, 175, 0.3);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const CancelButton = styled.button`
  width: 100%;
  padding: 16px;
  background: transparent;
  border: 2px solid #64748b;
  border-radius: 9999px;
  color: #64748b;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  margin-top: 12px;
  
  &:hover {
    background: #f8fafc;
  }
`;

const ErrorMessage = styled.div`
  background: #fef2f2;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 14px;
  margin-bottom: 20px;
  border: 1px solid #fecaca;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SuccessMessage = styled.div`
  background: #f0fdf4;
  color: #16a34a;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 14px;
  margin-bottom: 20px;
  border: 1px solid #bbf7d0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ToggleMode = styled.button`
  background: none;
  border: none;
  color: #6366f1;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;
  margin-top: 12px;
  padding: 8px;
  transition: color 0.3s;
  width: 100%;
  text-align: center;
  
  &:hover {
    color: #4f46e5;
    text-decoration: underline;
  }
`;

const ModeIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${props => props.isFirstTime ? '#eff6ff' : '#f0fdf4'};
  padding: 8px 14px;
  border-radius: 12px;
  margin-bottom: 20px;
  border: 1px solid ${props => props.isFirstTime ? '#bfdbfe' : '#bbf7d0'};
  color: ${props => props.isFirstTime ? '#1e40af' : '#16a34a'};
  font-weight: 600;
  font-size: 14px;
  
  svg {
    font-size: 18px;
  }
`;

/* ================= MAIN COMPONENT ================= */
const Login = ({ setUser }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const [showLeadForm, setShowLeadForm] = useState(false);
  const [targetRoute, setTargetRoute] = useState("");
  const [leadData, setLeadData] = useState({
    fullName: "",
    email: "",
    phone: "",
  });
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [headerHeight, setHeaderHeight] = useState('70px');
  const [isCheckingEmail, setIsCheckingEmail] = useState(false);
  const [emailChecked, setEmailChecked] = useState(false); // Track if email has been checked
  
  // Video mute state
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);
  const checkEmailTimeout = useRef(null);

  const navigate = useNavigate();

  // Get header height for mobile menu positioning
  React.useEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.querySelector('header');
      if (header) {
        setHeaderHeight(`${header.offsetHeight}px`);
      }
    };
    
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
    
    return () => {
      window.removeEventListener('resize', updateHeaderHeight);
    };
  }, []);

  // Toggle video mute
  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  };



  // Check if email exists in backend
  const checkEmailExists = async (email) => {
    if (!email || email.length < 3) {
      setEmailChecked(false);
      return false;
    }
    
    setIsCheckingEmail(true);
    try {
      const response = await api.get(`/leads/check-email/${encodeURIComponent(email)}`);
      
      if (response.data.success && response.data.exists) {
        // Email exists - this is a returning visitor
        setIsFirstTime(false);
        setEmailChecked(true);
        setLeadData(prev => ({
          ...prev,
          fullName: response.data.data?.fullName || '',
          phone: response.data.data?.phone || ''
        }));
        return true;
      } else {
        // Email doesn't exist - new visitor
        setIsFirstTime(true);
        setEmailChecked(true);
        // Clear pre-filled data if any
        setLeadData(prev => ({
          ...prev,
          fullName: '',
          phone: ''
        }));
        return false;
      }
    } catch (error) {
      console.error('Error checking email:', error);
      setEmailChecked(false);
      return false;
    } finally {
      setIsCheckingEmail(false);
    }
  };

  // Handle email change with debounce
  useEffect(() => {
    // Clear previous timeout
    if (checkEmailTimeout.current) {
      clearTimeout(checkEmailTimeout.current);
    }
    
    // Set new timeout
    checkEmailTimeout.current = setTimeout(() => {
      if (leadData.email && leadData.email.includes('@') && leadData.email.includes('.')) {
        checkEmailExists(leadData.email);
      } else {
        setEmailChecked(false);
      }
    }, 600);
    
    return () => {
      if (checkEmailTimeout.current) {
        clearTimeout(checkEmailTimeout.current);
      }
    };
  }, [leadData.email]);



const handleProtectedNavigation = (route) => {
  console.log('Navigating to protected route:', route);
  setTargetRoute(route);
  setLeadData({ fullName: "", email: "", phone: "" });
  setError('');
  setIsFirstTime(true);
  setEmailChecked(false);
  setShowLeadForm(true);
  setIsMobileMenuOpen(false);
};

const submitLead = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');

  try {
    // Validation
    if (isFirstTime) {
      if (!leadData.fullName || !leadData.email || !leadData.phone) {
        setError('Please fill in all fields (Full Name, Email, and Phone)');
        setLoading(false);
        return;
      }
    } else {
      if (!leadData.email) {
        setError('Please enter your email address');
        setLoading(false);
        return;
      }
    }

    // Send to backend
    const response = await api.post('/leads', {
      fullName: leadData.fullName || "Guest",
      email: leadData.email,
      phone: leadData.phone || '',
      targetRoute: targetRoute || "/dashboard",
      conversionSource: "button",
      isFirstTime: isFirstTime
    });

    if (response.data.success) {
      const userData = {
        name: response.data.data.fullName || "Guest",
        email: response.data.data.email,
        phone: response.data.data.phone || '',
        isFirstTime: response.data.data.isFirstTime,
        visitCount: response.data.data.visitCount,
        leadId: response.data.data._id,
        role: "staff" // Adjust if needed
      };

      // Update user state
      setUser(userData);
      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("token", "your-auth-token-here");
      localStorage.setItem("leadId", response.data.data._id);

      // Close modal first
      setShowLeadForm(false);

      // Small delay to let state update
      setTimeout(() => {
        navigate(targetRoute || "/dashboard");
      }, 100);
    }
  } catch (error) {
    console.error("Lead submission error:", error);
    setError(error.response?.data?.message || "Failed to submit. Please try again.");
  } finally {
    setLoading(false);
  }
};

  const cancelLeadForm = () => {
    setShowLeadForm(false);
    setLeadData({ fullName: "", email: "", phone: "" });
    setError('');
    setIsFirstTime(true);
    setEmailChecked(false);
    if (checkEmailTimeout.current) {
      clearTimeout(checkEmailTimeout.current);
    }
  };

  // Toggle between first time and returning
  const toggleMode = () => {
    setIsFirstTime(!isFirstTime);
    setError('');
    setEmailChecked(false);
    if (!isFirstTime) {
      // Switching to first time mode - clear pre-filled data
      setLeadData(prev => ({ ...prev, fullName: "", phone: "" }));
    }
  };

  return (
    <LoginContainer>
      {/* Background Video */}
      <BackgroundVideo 
        ref={videoRef}
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source
          src="https://cdn1.kingschat.online/uploads/media/57fbe8f538da4d5569ad1cff/ODVSNjB0SS9PQlhUakxuQm5Zc0ZpUT09/808133.mp4"
          type="video/mp4"
        />
      </BackgroundVideo>
      
      <Overlay />

      {/* Header */}
      <Header>
        <LogoContainer onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <BrandLogo src={logo} alt="SPIRITMAN" />
        </LogoContainer>

        <Nav>
          <NavLink onClick={() => handleProtectedNavigation("/dashboard")}>HOME</NavLink>
          <NavLink onClick={() => navigate("/about")}>About Us</NavLink>
          <NavLink onClick={() => handleProtectedNavigation("/dashboard")}>Resources</NavLink>
          <NavLink onClick={() => handleProtectedNavigation("/live")}>Live Program</NavLink>
        </Nav>

        <HeaderRight>
          <KingsChatButton
            href="https://kingschat.online/user/spiritman.online"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SocialIcon 
              src="https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/VnBZbVVyUXBXNGE3R1lmVmVlZWJQQT09/kingsch.jpg" 
              alt="KingsChat" 
            />
            <SocialText>KingsChat</SocialText>
          </KingsChatButton>

          <ContactButton
            href="https://wa.link/ss0tjf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <MessageCircle size={16} />
            <SocialText>WhatsApp</SocialText>
          </ContactButton>

          <MobileMenuButton onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </MobileMenuButton>
        </HeaderRight>
      </Header>

      {/* Mobile Navigation */}
      <MobileNav isOpen={isMobileMenuOpen} headerHeight={headerHeight}>
        <MobileNavLink onClick={() => handleProtectedNavigation("/dashboard")}>HOME</MobileNavLink>
        <MobileNavLink onClick={() => navigate("/dashboard")}>About Us</MobileNavLink>
        <MobileNavLink onClick={() => handleProtectedNavigation("/dashboard")}>Resources</MobileNavLink>
        <MobileNavLink onClick={() => handleProtectedNavigation("/live")}>🔴 Live Program</MobileNavLink> {/* ADD THIS LINE */}

      </MobileNav>

      <MainContent>
        <HeroSection>
          <HeraldLogo>SPIRITMAN</HeraldLogo>
          <SubtitleText>Global Missions • AI for Church Growth • AI for Kingdom Business</SubtitleText>
          <Tagline>
            Empowering the Church with technology. Reaching the last lost soul through digital evangelism.
          </Tagline>
          
          <ButtonsContainer>
            <PrimaryButton
              onClick={() => handleProtectedNavigation("/evangelist")}
            >
              Become a DIGITAL EVANGELIST
            </PrimaryButton>
            
            <SecondaryButton
              onClick={() => handleProtectedNavigation("/resources")}
            >
              Access Resources
            </SecondaryButton>
          </ButtonsContainer>
        </HeroSection>
      </MainContent>

      {/* Mute/Unmute Button */}
      <MuteButton onClick={toggleMute}>
        {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
        <MuteTooltip>
          {isMuted ? 'Unmute' : 'Mute'}
        </MuteTooltip>
      </MuteButton>

      {/* Lead Capture Modal */}
      {showLeadForm && (
        <ModalOverlay>
          <ModalCard>
            <h2 style={{ marginBottom: '4px', fontSize: '1.75rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
              {isFirstTime ? '✨ New Here?' : '👋 Welcome Back!'}
            </h2>
            <p style={{ color: '#64748b', marginBottom: '24px', fontSize: '0.95rem' }}>
              {isFirstTime 
                ? 'Please fill in your details to get started.' 
                : `We remember you! Just confirm your email to continue.`}
            </p>
            
            <ModeIndicator isFirstTime={isFirstTime}>
              {isFirstTime ? (
                <>
                  <FaUserPlus /> First time visitor
                </>
              ) : (
                <>
                  <FaUserCheck /> Returning visitor
                </>
              )}
            </ModeIndicator>
            
            {error && (
              <ErrorMessage>
                <span>⚠️</span> {error}
              </ErrorMessage>
            )}
            
            <Form onSubmit={submitLead}>
              <FormGroup>
                <Label>Email Address</Label>
                <InputWithIcon>
                  <Mail size={20} />
                  <Input
                    type="email"
                    required
                    value={leadData.email}
                    onChange={(e) => setLeadData({ ...leadData, email: e.target.value })}
                    placeholder="you@example.com"
                    style={{ paddingLeft: '44px' }}
                  />
                </InputWithIcon>
                {isCheckingEmail && (
                  <div style={{ fontSize: '12px', color: '#6366f1', marginTop: '4px' }}>
                    <span style={{ display: 'inline-block', animation: 'spin 1s linear infinite' }}>⟳</span> Checking...
                  </div>
                )}
                {!isCheckingEmail && emailChecked && !isFirstTime && leadData.email && (
                  <div style={{ fontSize: '12px', color: '#16a34a', marginTop: '4px' }}>
                    ✓ Returning visitor - we found your details!
                  </div>
                )}
                {!isCheckingEmail && emailChecked && isFirstTime && leadData.email && (
                  <div style={{ fontSize: '12px', color: '#6366f1', marginTop: '4px' }}>
                    ✨ New visitor - please complete your profile
                  </div>
                )}
              </FormGroup>
              
              {isFirstTime && (
                <>
                  <FormGroup>
                    <Label>Full Name</Label>
                    <InputWithIcon>
                      <User size={20} />
                      <Input
                        value={leadData.fullName}
                        onChange={(e) => setLeadData({ ...leadData, fullName: e.target.value })}
                        placeholder="John Doe"
                        style={{ paddingLeft: '44px' }}
                        required
                      />
                    </InputWithIcon>
                  </FormGroup>
                  
                  <FormGroup>
                    <Label>Phone Number</Label>
                    <InputWithIcon>
                      <Phone size={20} />
                      <Input
                        value={leadData.phone}
                        onChange={(e) => setLeadData({ ...leadData, phone: e.target.value })}
                        placeholder="+234 801 234 5678"
                        style={{ paddingLeft: '44px' }}
                        required
                      />
                    </InputWithIcon>
                  </FormGroup>
                </>
              )}

              <SubmitButton type="submit" disabled={loading}>
                {loading ? 'Please wait...' : isFirstTime ? 'Get Started 🚀' : 'Continue →'}
              </SubmitButton>
              
              <ToggleMode type="button" onClick={toggleMode}>
                {isFirstTime ? 'Already have an account? Sign in with email' : 'New user? Register with full details'}
              </ToggleMode>
              
              <CancelButton type="button" onClick={cancelLeadForm}>
                Cancel
              </CancelButton>
            </Form>
          </ModalCard>
        </ModalOverlay>
      )}
    </LoginContainer>
  );
};

export default Login;